{
  "id": "captureflag",
  "name": "Capture the Flag",
  "specialRules": [
    "Four players are each randomly assigned one home base.",
    "Each player starts with 5 troops on their fort and 5 on their tower.",
    "Towers can attack every territory in their area: base towers cover their entire base, and the High Tower covers the middle.",
    "Towers attack with a 9-sided die; forts and keeps defend with a 7-sided die; flags defend with a 5-sided die.",
    "Posterns and sallies defend with an 8-sided die against the center and attack their nearest keep, two territories away in the middle, with a 7-sided die.",
    "Middle barbicans defend with a 7-sided die."
  ],
  "backgroundImage": "captureflag",
  "wallsOverlay": "captureflag-walls",
  "hideAdjacencyLines": true,
  "viewBox": {
    "x": 25.64,
    "y": 0,
    "width": 1146.36,
    "height": 1342
  },
  "backdropColor": {
    "light": "#e9dcb8",
    "dark": "#24251f",
    "topBar": true
  },
  "gameLayout": {
    "topBarOverlap": 0.65
  },
  "selectionInnerGlow": false,
  "edgeConfig": {
    "internalBorderWidth": 0,
    "regionBorderWidth": 0,
    "bridgeStrokeWidth": 0
  },
  "fixedSetup": {
    "playerCount": 4,
    "areas": [
      {
        "id": "Stone",
        "armies": {
          "t7": 5,
          "t11": 5
        }
      },
      {
        "id": "Mire",
        "armies": {
          "t12": 5,
          "t9": 5
        }
      },
      {
        "id": "Spire",
        "armies": {
          "t5": 5,
          "t2": 5
        }
      },
      {
        "id": "Iron",
        "armies": {
          "t1": 5,
          "t3": 5
        }
      }
    ],
    "neutralArmies": 3,
    "neutralOverrides": {
      "t6": 5,
      "t18": 6,
      "t21": 6,
      "t42": 5,
      "t43": 5,
      "t51": 6,
      "t54": 6,
      "t58": 6,
      "t62": 6,
      "t63": 5,
      "t67": 5,
      "t91": 6,
      "t92": 6
    },
    "config": {
      "cardBonusSchedule": "incremental"
    }
  },
  "regions": [
    {
      "id": "flag-t17",
      "name": "Iron Flag",
      "bonus": 3,
      "territoryIds": [
        "t17"
      ],
      "shape": "M 220.0 291.71 L 220.0 281.0 L 222.0 279.0 L 220.0 278.0 L 216.0 280.0 L 217.0 291.0 L 230.0 298.0 L 235.0 298.0 L 253.0 308.0 L 255.0 312.0 L 260.0 312.0 L 310.0 340.0 L 314.0 341.0 L 387.0 276.0 L 393.0 274.0 L 391.0 212.0 L 391.0 137.0 L 399.07 130.28 L 398.0 172.0 L 399.0 187.0 L 401.0 187.0 L 401.0 141.0 L 415.0 129.0 L 413.0 128.0 L 409.0 132.0 L 409.0 121.0 L 411.0 119.0 L 409.0 118.0 L 397.0 130.0 L 392.0 134.0 L 388.0 134.0 L 378.0 144.0 L 380.0 145.0 L 387.0 139.0 L 388.0 148.0 L 371.0 164.0 L 371.0 167.0 L 245.0 274.0 L 240.0 278.0 L 237.0 277.0 L 235.0 279.0 L 232.0 279.0 L 229.0 284.0 L 220.0 291.71 Z",
      "color": "#9FA8DA",
      "bonusAnchor": {
        "x": 274.96,
        "y": 208.23
      }
    },
    {
      "id": "flag-t23",
      "name": "Spire Flag",
      "bonus": 3,
      "territoryIds": [
        "t23"
      ],
      "shape": "M 925.0 213.0 L 924.0 214.0 L 922.0 215.0 L 922.0 318.0 L 988.0 385.0 L 1012.0 380.0 L 1023.0 381.0 L 1028.0 380.0 L 1030.0 377.0 L 1040.0 378.0 L 1051.0 376.0 L 1056.0 375.0 L 1057.0 372.0 L 1083.0 367.0 L 925.0 213.0 Z",
      "color": "#9FA8DA",
      "bonusAnchor": {
        "x": 1035.06,
        "y": 276.58
      }
    },
    {
      "id": "flag-t42",
      "name": "Dawn Flag",
      "bonus": 3,
      "territoryIds": [
        "t42"
      ],
      "shape": "M 720.0 404.0 L 719.0 405.0 L 709.0 505.0 L 710.0 507.0 L 712.0 507.0 L 723.0 518.0 L 791.0 595.0 L 883.0 594.0 L 800.0 501.0 L 743.0 442.0 L 743.0 431.0 L 745.0 429.0 L 742.0 426.0 L 741.0 427.0 L 740.0 435.0 L 724.0 419.0 L 724.0 410.0 L 736.0 422.0 L 737.0 420.0 L 720.0 404.0 Z",
      "color": "#9FA8DA",
      "bonusAnchor": {
        "x": 831.09,
        "y": 500.68
      }
    },
    {
      "id": "flag-t43",
      "name": "Frost Flag",
      "bonus": 3,
      "territoryIds": [
        "t43"
      ],
      "shape": "M 554.0 423.0 L 484.0 484.0 L 481.0 483.0 L 477.0 486.0 L 461.0 504.0 L 413.0 544.0 L 414.0 546.0 L 419.0 547.0 L 478.0 557.0 L 544.0 500.0 L 547.0 498.0 L 549.0 499.0 L 553.0 495.0 L 557.0 431.0 L 559.0 426.0 L 558.0 417.0 L 557.0 418.0 L 555.0 424.0 L 554.0 423.0 Z",
      "color": "#9FA8DA",
      "bonusAnchor": {
        "x": 485.66,
        "y": 451.85
      }
    },
    {
      "id": "flag-t63",
      "name": "Dusk Flag",
      "bonus": 3,
      "territoryIds": [
        "t63"
      ],
      "shape": "M 365.0 734.0 L 364.0 735.0 L 367.0 738.0 L 367.0 742.0 L 371.0 747.0 L 369.0 752.0 L 371.0 755.0 L 379.0 761.0 L 429.0 824.0 L 428.0 827.0 L 437.0 834.0 L 439.0 837.0 L 438.0 839.0 L 441.0 843.0 L 450.0 850.0 L 450.0 854.0 L 458.0 860.0 L 511.0 924.0 L 514.0 928.0 L 513.0 930.0 L 516.0 933.0 L 517.0 932.0 L 523.0 879.0 L 525.0 877.0 L 524.0 872.0 L 528.0 842.0 L 525.0 832.0 L 522.0 832.0 L 524.0 841.0 L 519.0 841.0 L 489.0 807.0 L 448.0 759.0 L 450.0 756.0 L 448.6 747.6 L 452.0 751.0 L 453.0 749.0 L 448.0 744.0 L 382.0 736.0 L 372.0 736.0 L 365.0 734.0 Z",
      "color": "#9FA8DA",
      "bonusAnchor": {
        "x": 435.87,
        "y": 870.75
      }
    },
    {
      "id": "flag-t67",
      "name": "Ember Flag",
      "bonus": 3,
      "territoryIds": [
        "t67"
      ],
      "shape": "M 772.0 803.0 L 773.0 804.0 L 764.0 813.0 L 721.0 849.0 L 705.0 862.0 L 702.0 861.0 L 696.0 866.0 L 695.0 858.0 L 692.0 858.0 L 680.0 974.0 L 680.0 977.0 L 682.0 979.0 L 684.0 977.0 L 687.0 979.0 L 690.0 976.0 L 690.0 973.0 L 720.0 947.0 L 872.0 807.0 L 873.0 808.0 L 875.0 806.0 L 877.0 791.0 L 876.0 785.0 L 790.0 777.0 L 789.0 778.0 L 776.0 789.0 L 778.0 790.0 L 787.0 782.0 L 788.0 789.0 L 772.0 803.0 Z",
      "color": "#9FA8DA",
      "bonusAnchor": {
        "x": 815,
        "y": 888.84
      }
    },
    {
      "id": "flag-t84",
      "name": "Stone Flag",
      "bonus": 3,
      "territoryIds": [
        "t84"
      ],
      "shape": "M 140.0 974.0 L 141.0 973.0 L 146.0 978.0 L 296.0 1155.0 L 301.0 1160.0 L 303.0 1158.0 L 306.0 1160.0 L 308.0 1159.0 L 306.0 1155.0 L 310.0 1117.0 L 310.0 1098.0 L 312.0 1092.0 L 311.0 1083.0 L 315.0 1038.0 L 313.0 1032.0 L 311.0 1032.0 L 311.0 1043.34 L 251.0 973.0 L 248.0 969.0 L 250.0 965.0 L 248.33 958.33 L 254.0 964.0 L 255.0 962.0 L 248.0 954.0 L 246.8 955.2 L 246.09 955.16 L 245.0 965.0 L 227.0 965.0 L 227.0 957.0 L 240.0 957.0 L 243.0 955.0 L 224.0 954.0 L 223.0 955.0 L 137.0 956.0 L 131.0 961.0 L 138.0 969.0 L 137.0 972.0 L 140.0 974.0 Z",
      "color": "#9FA8DA",
      "bonusAnchor": {
        "x": 194.11,
        "y": 1076.11
      }
    },
    {
      "id": "flag-t87",
      "name": "Mire Flag",
      "bonus": 3,
      "territoryIds": [
        "t87"
      ],
      "shape": "M 934.0 1028.0 L 933.0 1029.0 L 907.0 1054.0 L 909.0 1055.0 L 932.0 1032.0 L 932.0 1040.0 L 928.0 1045.0 L 929.0 1047.0 L 898.0 1077.0 L 895.0 1076.0 L 884.0 1087.0 L 882.0 1084.0 L 880.0 1090.0 L 866.0 1104.0 L 865.0 1097.0 L 871.0 1091.0 L 869.0 1090.0 L 862.0 1097.0 L 862.0 1147.0 L 859.0 1218.0 L 860.0 1226.0 L 858.0 1241.0 L 863.0 1244.0 L 863.0 1240.0 L 865.0 1237.0 L 1031.0 1079.0 L 1034.0 1079.0 L 1036.0 1076.0 L 1035.0 1072.0 L 1043.0 1064.0 L 1042.0 1063.0 L 947.0 1031.0 L 934.0 1028.0 Z",
      "color": "#9FA8DA",
      "bonusAnchor": {
        "x": 971.82,
        "y": 1177.75
      }
    },
    {
      "id": "capital-stonewatch",
      "name": "Stone Fort",
      "bonus": 4,
      "territoryIds": [
        "t7"
      ],
      "shape": "M 135.0 695.0 L 134.0 696.0 L 135.0 699.0 L 133.0 703.0 L 133.0 709.0 L 116.0 723.0 L 116.0 738.0 L 107.0 745.0 L 106.0 753.0 L 99.0 758.0 L 99.0 753.0 L 98.0 752.0 L 96.0 754.0 L 94.0 767.0 L 123.0 801.0 L 143.0 801.0 L 174.0 771.0 L 174.0 757.0 L 172.0 757.0 L 171.0 762.0 L 160.0 753.0 L 160.0 748.0 L 153.0 737.0 L 155.0 725.0 L 146.0 715.0 L 155.0 705.0 L 145.0 700.0 L 139.0 699.0 L 135.0 695.0 Z",
      "color": "#B8F000",
      "bonusAnchor": {
        "x": 54.65,
        "y": 760.53
      }
    },
    {
      "id": "artillery-stonewatch",
      "name": "Stone Battery",
      "bonus": 2,
      "territoryIds": [
        "t10"
      ],
      "shape": "M 499.0 1064.0 L 498.0 1065.0 L 495.0 1066.0 L 495.0 1068.0 L 488.0 1076.0 L 490.0 1078.0 L 490.0 1082.0 L 487.0 1086.0 L 480.0 1088.0 L 479.0 1103.0 L 496.0 1123.0 L 502.0 1128.0 L 517.0 1116.0 L 517.0 1114.0 L 526.0 1106.0 L 518.0 1097.0 L 518.0 1090.0 L 516.0 1088.0 L 517.0 1084.0 L 514.0 1081.0 L 517.0 1077.0 L 513.0 1073.0 L 511.0 1066.0 L 509.0 1065.0 L 507.0 1067.0 L 499.0 1064.0 Z",
      "color": "#B8F000",
      "bonusAnchor": {
        "x": 562.1,
        "y": 1103.9
      }
    },
    {
      "id": "capital-mirefast",
      "name": "Mire Fort",
      "bonus": 4,
      "territoryIds": [
        "t12"
      ],
      "shape": "M 718.0 1200.0 L 718.0 1207.0 L 700.0 1223.0 L 699.0 1231.0 L 689.0 1236.0 L 673.0 1248.0 L 671.0 1278.0 L 707.0 1316.0 L 731.0 1316.0 L 768.0 1281.0 L 768.0 1254.0 L 756.0 1242.0 L 744.0 1235.0 L 740.0 1231.0 L 740.0 1222.0 L 730.0 1212.0 L 737.0 1204.0 L 732.0 1199.0 L 722.0 1196.0 L 718.0 1200.0 Z",
      "color": "#CE93D8",
      "bonusAnchor": {
        "x": 643.12,
        "y": 1266.49
      }
    },
    {
      "id": "artillery-mirefast",
      "name": "Mire Battery",
      "bonus": 2,
      "territoryIds": [
        "t8"
      ],
      "shape": "M 1017.0 752.0 L 1016.0 753.0 L 1015.0 756.0 L 1006.0 765.0 L 1006.0 774.0 L 1008.0 776.0 L 1006.0 778.0 L 1006.0 796.0 L 1004.0 799.0 L 1020.0 815.0 L 1022.0 815.0 L 1030.0 806.0 L 1039.0 799.0 L 1038.0 779.0 L 1036.0 777.0 L 1039.0 773.0 L 1039.0 769.0 L 1037.0 767.0 L 1038.0 764.0 L 1033.0 758.0 L 1033.0 755.0 L 1029.0 752.0 L 1021.0 754.0 L 1017.0 752.0 Z",
      "color": "#CE93D8",
      "bonusAnchor": {
        "x": 972.05,
        "y": 798.59
      }
    },
    {
      "id": "capital-sunspire",
      "name": "Spire Fort",
      "bonus": 4,
      "territoryIds": [
        "t5"
      ],
      "shape": "M 1081.0 481.0 L 1080.0 482.0 L 1079.0 504.0 L 1065.0 515.0 L 1065.0 530.0 L 1059.0 536.0 L 1058.0 540.0 L 1048.0 549.0 L 1048.0 555.0 L 1075.0 583.0 L 1092.0 583.0 L 1118.0 558.0 L 1118.0 554.0 L 1107.0 544.0 L 1106.0 536.0 L 1101.0 530.0 L 1102.0 517.0 L 1087.0 504.0 L 1093.0 498.0 L 1095.0 498.0 L 1101.0 493.0 L 1091.0 487.0 L 1087.0 487.0 L 1083.0 481.0 L 1081.0 481.0 Z",
      "color": "#FF6B6B",
      "bonusAnchor": {
        "x": 1155.71,
        "y": 560.94
      }
    },
    {
      "id": "artillery-sunspire",
      "name": "Spire Battery",
      "bonus": 2,
      "territoryIds": [
        "t13"
      ],
      "shape": "M 748.0 232.0 L 750.8 234.8 L 740.0 236.0 L 741.0 240.0 L 738.0 244.0 L 735.0 241.0 L 734.0 242.0 L 736.0 245.0 L 736.0 264.0 L 734.0 266.0 L 736.0 268.0 L 736.0 272.0 L 731.0 274.0 L 731.0 278.0 L 752.0 298.0 L 756.0 296.0 L 770.0 282.0 L 779.0 277.0 L 777.0 270.0 L 776.0 269.0 L 774.0 272.0 L 770.0 267.0 L 770.0 254.0 L 768.0 252.0 L 769.0 248.0 L 762.0 239.0 L 758.0 236.0 L 755.0 236.0 L 749.0 231.0 L 748.0 232.0 Z",
      "color": "#FF6B6B",
      "bonusAnchor": {
        "x": 694.86,
        "y": 288.16
      }
    },
    {
      "id": "capital-ironhold",
      "name": "Iron Fort",
      "bonus": 4,
      "territoryIds": [
        "t1"
      ],
      "shape": "M 499.0 100.0 L 499.0 107.0 L 488.0 116.0 L 488.0 124.0 L 518.0 154.0 L 535.0 154.0 L 551.0 141.0 L 568.0 124.0 L 568.0 119.0 L 554.0 105.0 L 554.0 100.0 L 549.0 94.0 L 551.0 91.0 L 548.0 88.0 L 548.0 78.0 L 550.0 76.0 L 542.0 68.0 L 549.0 61.0 L 547.0 59.0 L 535.0 56.0 L 529.0 51.0 L 528.0 52.0 L 528.0 63.0 L 509.0 77.0 L 508.0 88.0 L 502.0 93.0 L 496.0 94.0 L 492.0 97.0 L 502.0 97.0 L 499.0 100.0 Z",
      "color": "#00E5CC",
      "bonusAnchor": {
        "x": 607.96,
        "y": 124.94
      }
    },
    {
      "id": "artillery-ironhold",
      "name": "Iron Battery",
      "bonus": 2,
      "territoryIds": [
        "t4"
      ],
      "shape": "M 255.0 473.0 L 254.0 474.0 L 252.0 474.0 L 251.0 477.0 L 243.0 484.0 L 243.0 487.0 L 245.0 489.0 L 242.0 492.0 L 244.0 495.0 L 242.0 498.0 L 243.0 510.0 L 240.0 513.0 L 240.0 516.0 L 256.0 533.0 L 262.0 537.0 L 282.0 519.0 L 280.0 514.0 L 275.0 509.0 L 274.0 499.0 L 272.0 497.0 L 275.0 494.0 L 275.0 485.0 L 267.0 474.0 L 263.0 475.0 L 255.0 473.0 Z",
      "color": "#00E5CC",
      "bonusAnchor": {
        "x": 310.04,
        "y": 521.13
      }
    }
  ],
  "territories": [
    {
      "id": "t1",
      "name": "Iron Fort",
      "regionId": "capital-ironhold",
      "adjacencies": [
        "t15"
      ],
      "borderDice": {
        "t3": {
          "defend": 7
        },
        "t15": {
          "defend": 7
        }
      },
      "shape": "M 529.0 51.0 L 535.0 56.0 L 547.0 59.0 L 549.0 61.0 L 542.0 68.0 L 550.0 76.0 L 548.0 78.0 L 548.0 88.0 L 551.0 91.0 L 549.0 94.0 L 554.0 100.0 L 554.0 105.0 L 568.0 119.0 L 568.0 124.0 L 551.0 141.0 L 535.0 154.0 L 518.0 154.0 L 488.0 124.0 L 488.0 116.0 L 499.0 107.0 L 499.0 100.0 L 502.0 97.0 L 492.0 97.0 L 496.0 94.0 L 502.0 93.0 L 508.0 88.0 L 509.0 77.0 L 528.0 63.0 L 528.0 52.0 Z",
      "position": {
        "x": 528,
        "y": 110
      },
      "badgeAnchor": {
        "x": 528.17,
        "y": 135.77
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t2",
      "name": "Spire Tower",
      "adjacencies": [
        "t19",
        "t25",
        "t21"
      ],
      "oneWayBorders": [
        "t5",
        "t23",
        "t28",
        "t32",
        "t36",
        "t37",
        "t39",
        "t41",
        "t46",
        "t54",
        "t13"
      ],
      "borderDice": {
        "t5": {
          "attack": 9
        },
        "t13": {
          "attack": 9
        },
        "t19": {
          "attack": 9
        },
        "t21": {
          "attack": 9
        },
        "t23": {
          "attack": 9
        },
        "t25": {
          "attack": 9
        },
        "t28": {
          "attack": 9
        },
        "t32": {
          "attack": 9
        },
        "t36": {
          "attack": 9
        },
        "t37": {
          "attack": 9
        },
        "t39": {
          "attack": 9
        },
        "t41": {
          "attack": 9
        },
        "t46": {
          "attack": 9
        },
        "t54": {
          "attack": 9
        }
      },
      "maxArmies": 7,
      "shape": "M 801.0 94.0 L 804.0 97.0 L 804.0 103.0 L 889.0 180.0 L 891.0 182.0 L 889.0 185.0 L 887.0 187.0 L 884.0 187.0 L 872.0 199.0 L 871.0 198.0 L 860.0 206.0 L 853.0 214.0 L 852.0 213.0 L 849.0 217.0 L 848.0 216.0 L 845.0 220.0 L 844.0 219.0 L 829.0 233.0 L 828.0 232.0 L 824.0 235.0 L 820.0 240.0 L 817.0 240.0 L 814.0 244.0 L 809.0 247.0 L 807.0 251.0 L 806.0 250.0 L 802.0 253.0 L 771.0 252.0 L 769.0 254.0 L 767.0 252.0 L 768.0 248.0 L 764.0 242.0 L 745.0 227.0 L 709.0 191.0 L 710.0 180.0 L 714.0 178.0 L 714.0 175.0 L 724.0 163.0 L 726.0 165.0 L 790.0 111.0 L 795.0 106.0 L 795.0 101.0 L 800.0 99.0 L 800.0 95.0 Z",
      "position": {
        "x": 796,
        "y": 182
      },
      "badgeAnchor": {
        "x": 807.91,
        "y": 157.23
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t3",
      "name": "Iron Tower",
      "adjacencies": [
        "t27",
        "t40",
        "t51"
      ],
      "oneWayBorders": [
        "t1",
        "t4",
        "t15",
        "t16",
        "t17",
        "t18",
        "t20",
        "t24",
        "t26",
        "t29",
        "t33"
      ],
      "borderDice": {
        "t1": {
          "attack": 9
        },
        "t4": {
          "attack": 9
        },
        "t15": {
          "attack": 9
        },
        "t16": {
          "attack": 9
        },
        "t17": {
          "attack": 9
        },
        "t18": {
          "attack": 9
        },
        "t20": {
          "attack": 9
        },
        "t24": {
          "attack": 9
        },
        "t26": {
          "attack": 9
        },
        "t27": {
          "attack": 9
        },
        "t29": {
          "attack": 9
        },
        "t33": {
          "attack": 9
        },
        "t40": {
          "attack": 9
        },
        "t51": {
          "attack": 9
        }
      },
      "maxArmies": 7,
      "shape": "M 171.0 337.0 L 245.0 410.0 L 221.0 498.0 L 176.0 541.0 L 167.0 542.0 L 68.0 428.0 L 170.0 338.0 Z",
      "position": {
        "x": 165,
        "y": 438
      },
      "badgeAnchor": {
        "x": 142.09,
        "y": 415.74
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t4",
      "name": "Iron Battery",
      "regionId": "artillery-ironhold",
      "adjacencies": [
        "t51"
      ],
      "shape": "M 255.0 473.0 L 263.0 475.0 L 267.0 474.0 L 275.0 485.0 L 275.0 494.0 L 272.0 497.0 L 274.0 499.0 L 275.0 509.0 L 280.0 514.0 L 282.0 519.0 L 262.0 537.0 L 256.0 533.0 L 240.0 516.0 L 240.0 513.0 L 243.0 510.0 L 242.0 498.0 L 244.0 495.0 L 242.0 492.0 L 245.0 489.0 L 243.0 487.0 L 243.0 484.0 L 251.0 477.0 L 252.0 474.0 L 254.0 474.0 Z",
      "position": {
        "x": 259,
        "y": 504
      },
      "badgeAnchor": {
        "x": 256.26,
        "y": 529.1
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t5",
      "name": "Spire Fort",
      "regionId": "capital-sunspire",
      "adjacencies": [
        "t41"
      ],
      "borderDice": {
        "t2": {
          "defend": 7
        },
        "t41": {
          "defend": 7
        }
      },
      "shape": "M 1081.0 481.0 L 1083.0 481.0 L 1087.0 487.0 L 1091.0 487.0 L 1101.0 493.0 L 1095.0 498.0 L 1093.0 498.0 L 1087.0 504.0 L 1102.0 517.0 L 1101.0 530.0 L 1106.0 536.0 L 1107.0 544.0 L 1118.0 554.0 L 1118.0 558.0 L 1092.0 583.0 L 1075.0 583.0 L 1048.0 555.0 L 1048.0 549.0 L 1058.0 540.0 L 1059.0 536.0 L 1065.0 530.0 L 1065.0 515.0 L 1079.0 504.0 L 1080.0 482.0 Z",
      "position": {
        "x": 1083,
        "y": 542
      },
      "badgeAnchor": {
        "x": 1084.32,
        "y": 565.17
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t6",
      "name": "High Tower",
      "adjacencies": [
        "t48",
        "t50",
        "t59",
        "t61"
      ],
      "oneWayBorders": [
        "t35",
        "t42",
        "t43",
        "t44",
        "t53",
        "t55",
        "t56",
        "t57",
        "t63",
        "t67",
        "t70",
        "t82"
      ],
      "borderDice": {
        "t35": {
          "attack": 9
        },
        "t42": {
          "attack": 9
        },
        "t43": {
          "attack": 9
        },
        "t44": {
          "attack": 9
        },
        "t48": {
          "attack": 9
        },
        "t50": {
          "attack": 9
        },
        "t53": {
          "attack": 9
        },
        "t55": {
          "attack": 9
        },
        "t56": {
          "attack": 9
        },
        "t57": {
          "attack": 9
        },
        "t59": {
          "attack": 9
        },
        "t61": {
          "attack": 9
        },
        "t63": {
          "attack": 9
        },
        "t67": {
          "attack": 9
        },
        "t70": {
          "attack": 9
        },
        "t82": {
          "attack": 9
        }
      },
      "maxArmies": 7,
      "shape": "M 611.0 554.0 L 665.0 600.0 L 666.0 604.0 L 655.0 614.0 L 658.0 617.0 L 659.0 652.0 L 661.0 662.0 L 669.0 667.0 L 682.0 680.0 L 682.0 693.0 L 621.0 744.0 L 593.0 744.0 L 534.0 690.0 L 535.0 677.0 L 555.0 662.0 L 557.0 648.0 L 559.0 645.0 L 559.0 613.0 L 562.0 610.0 L 553.0 600.0 L 603.0 558.0 L 607.0 555.0 L 610.0 555.0 Z",
      "position": {
        "x": 608,
        "y": 655
      },
      "badgeAnchor": {
        "x": 609.33,
        "y": 607.83
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t7",
      "name": "Stone Fort",
      "regionId": "capital-stonewatch",
      "adjacencies": [
        "t60"
      ],
      "borderDice": {
        "t11": {
          "defend": 7
        },
        "t60": {
          "defend": 7
        }
      },
      "shape": "M 135.0 695.0 L 139.0 699.0 L 145.0 700.0 L 155.0 705.0 L 146.0 715.0 L 155.0 725.0 L 153.0 737.0 L 160.0 748.0 L 160.0 753.0 L 171.0 762.0 L 172.0 757.0 L 174.0 757.0 L 174.0 771.0 L 143.0 801.0 L 123.0 801.0 L 94.0 767.0 L 96.0 754.0 L 98.0 752.0 L 99.0 753.0 L 99.0 758.0 L 106.0 753.0 L 107.0 745.0 L 116.0 738.0 L 116.0 723.0 L 133.0 709.0 L 133.0 703.0 L 135.0 699.0 L 134.0 696.0 Z",
      "position": {
        "x": 134,
        "y": 756
      },
      "badgeAnchor": {
        "x": 135.8,
        "y": 781.68
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t8",
      "name": "Mire Battery",
      "regionId": "artillery-mirefast",
      "adjacencies": [
        "t62"
      ],
      "shape": "M 1017.0 752.0 L 1021.0 754.0 L 1029.0 752.0 L 1033.0 755.0 L 1033.0 758.0 L 1038.0 764.0 L 1037.0 767.0 L 1039.0 769.0 L 1039.0 773.0 L 1036.0 777.0 L 1038.0 779.0 L 1039.0 799.0 L 1030.0 806.0 L 1022.0 815.0 L 1020.0 815.0 L 1004.0 799.0 L 1006.0 796.0 L 1006.0 778.0 L 1008.0 776.0 L 1006.0 774.0 L 1006.0 765.0 L 1015.0 756.0 L 1016.0 753.0 Z",
      "position": {
        "x": 1021,
        "y": 782
      },
      "badgeAnchor": {
        "x": 1020.48,
        "y": 807.03
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t9",
      "name": "Mire Tower",
      "adjacencies": [
        "t62",
        "t71",
        "t78",
        "t85"
      ],
      "oneWayBorders": [
        "t8",
        "t12",
        "t14",
        "t87",
        "t90",
        "t92",
        "t93",
        "t88",
        "t74",
        "t77"
      ],
      "borderDice": {
        "t8": {
          "attack": 9
        },
        "t12": {
          "attack": 9
        },
        "t14": {
          "attack": 9
        },
        "t62": {
          "attack": 9
        },
        "t71": {
          "attack": 9
        },
        "t74": {
          "attack": 9
        },
        "t77": {
          "attack": 9
        },
        "t78": {
          "attack": 9
        },
        "t85": {
          "attack": 9
        },
        "t87": {
          "attack": 9
        },
        "t88": {
          "attack": 9
        },
        "t90": {
          "attack": 9
        },
        "t92": {
          "attack": 9
        },
        "t93": {
          "attack": 9
        }
      },
      "maxArmies": 7,
      "shape": "M 1094.0 759.0 L 1096.0 760.0 L 1096.0 762.0 L 1111.0 785.0 L 1111.0 797.0 L 1061.0 844.0 L 1158.0 951.0 L 1082.0 1026.0 L 1070.0 1017.0 L 1040.0 989.0 L 1026.0 954.0 L 1024.0 952.0 L 1020.0 939.0 L 1009.0 916.0 L 1007.0 910.0 L 1011.0 895.0 L 1011.0 888.0 L 1014.0 880.0 L 1020.0 843.0 L 1000.0 823.0 L 996.0 824.0 L 927.0 890.0 L 930.0 894.0 L 929.0 895.0 L 919.0 884.0 L 919.0 882.0 L 997.0 808.0 L 993.0 803.0 L 828.0 961.0 L 817.0 970.0 L 807.0 983.0 L 839.0 1019.0 L 846.0 1019.0 L 878.0 989.0 L 879.0 990.0 L 846.0 1022.0 L 847.0 1029.0 L 849.0 1031.0 L 845.0 1035.0 L 837.0 1034.0 L 810.0 1006.0 L 763.0 1050.0 L 765.0 1053.0 L 764.0 1054.0 L 760.0 1052.0 L 708.0 1101.0 L 705.0 1101.0 L 712.0 1094.0 L 712.0 1088.0 L 713.0 1087.0 L 715.0 1091.0 L 732.0 1075.0 L 731.0 1067.0 L 707.0 1090.0 L 701.0 1095.0 L 700.0 1094.0 L 806.0 994.0 L 809.0 989.0 L 805.0 985.0 L 778.0 1011.0 L 777.0 1010.0 L 802.0 986.0 L 805.0 982.0 L 803.0 980.0 L 804.0 979.0 L 807.0 981.0 L 810.0 975.0 L 817.0 968.0 L 993.0 801.0 L 995.0 798.0 L 996.0 791.0 L 1002.0 785.0 L 1004.0 786.0 L 998.0 792.0 L 997.0 799.0 L 995.0 802.0 L 1019.0 826.0 L 1021.0 826.0 L 1051.0 797.0 L 1054.0 797.0 L 1073.0 780.0 L 1093.0 760.0 Z M 1078.0 778.0 L 1076.0 791.0 L 1059.0 808.0 L 1058.0 807.0 L 1045.0 818.0 L 1038.0 821.0 L 1031.0 829.0 L 1022.0 836.0 L 1022.0 829.0 L 1046.0 807.0 L 1047.0 808.0 L 1051.0 805.0 L 1054.0 800.0 L 1077.0 779.0 Z",
      "position": {
        "x": 1056,
        "y": 917
      },
      "badgeAnchor": {
        "x": 1082.33,
        "y": 919.33
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t10",
      "name": "Stone Battery",
      "regionId": "artillery-stonewatch",
      "adjacencies": [
        "t91"
      ],
      "shape": "M 499.0 1064.0 L 507.0 1067.0 L 509.0 1065.0 L 511.0 1066.0 L 513.0 1073.0 L 517.0 1077.0 L 514.0 1081.0 L 517.0 1084.0 L 516.0 1088.0 L 518.0 1090.0 L 518.0 1097.0 L 526.0 1106.0 L 517.0 1114.0 L 517.0 1116.0 L 502.0 1128.0 L 496.0 1123.0 L 479.0 1103.0 L 480.0 1088.0 L 487.0 1086.0 L 490.0 1082.0 L 490.0 1078.0 L 488.0 1076.0 L 495.0 1068.0 L 495.0 1066.0 L 498.0 1065.0 Z",
      "position": {
        "x": 501,
        "y": 1096
      },
      "badgeAnchor": {
        "x": 500.49,
        "y": 1113.83
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t11",
      "name": "Stone Tower",
      "adjacencies": [
        "t86",
        "t89",
        "t91"
      ],
      "oneWayBorders": [
        "t7",
        "t10",
        "t58",
        "t60",
        "t64",
        "t68",
        "t73",
        "t75",
        "t76",
        "t79",
        "t84"
      ],
      "borderDice": {
        "t7": {
          "attack": 9
        },
        "t10": {
          "attack": 9
        },
        "t58": {
          "attack": 9
        },
        "t60": {
          "attack": 9
        },
        "t64": {
          "attack": 9
        },
        "t68": {
          "attack": 9
        },
        "t73": {
          "attack": 9
        },
        "t75": {
          "attack": 9
        },
        "t76": {
          "attack": 9
        },
        "t79": {
          "attack": 9
        },
        "t84": {
          "attack": 9
        },
        "t86": {
          "attack": 9
        },
        "t89": {
          "attack": 9
        },
        "t91": {
          "attack": 9
        }
      },
      "maxArmies": 7,
      "shape": "M 404.0 1086.0 L 467.0 1109.0 L 468.0 1118.0 L 497.0 1148.0 L 501.0 1155.0 L 541.0 1200.0 L 483.0 1254.0 L 427.0 1303.0 L 316.0 1178.0 L 403.0 1087.0 Z",
      "position": {
        "x": 427,
        "y": 1189
      },
      "badgeAnchor": {
        "x": 415.07,
        "y": 1163.24
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t12",
      "name": "Mire Fort",
      "regionId": "capital-mirefast",
      "adjacencies": [
        "t14"
      ],
      "borderDice": {
        "t9": {
          "defend": 7
        },
        "t14": {
          "defend": 7
        }
      },
      "shape": "M 722.0 1196.0 L 732.0 1199.0 L 737.0 1204.0 L 730.0 1212.0 L 740.0 1222.0 L 740.0 1231.0 L 744.0 1235.0 L 756.0 1242.0 L 768.0 1254.0 L 768.0 1281.0 L 731.0 1316.0 L 707.0 1316.0 L 671.0 1278.0 L 673.0 1248.0 L 689.0 1236.0 L 699.0 1231.0 L 700.0 1223.0 L 718.0 1207.0 L 718.0 1200.0 L 721.0 1197.0 Z M 695.0 1238.0 L 691.0 1242.0 L 691.0 1246.0 L 685.0 1251.0 L 682.0 1247.0 L 680.0 1249.0 L 678.0 1264.0 L 709.0 1300.0 L 728.0 1300.0 L 728.0 1313.0 L 710.0 1313.0 L 710.0 1307.0 L 708.0 1305.0 L 705.0 1307.0 L 705.0 1310.0 L 675.0 1278.0 L 675.0 1268.0 L 677.0 1266.0 L 675.0 1263.0 L 677.0 1248.0 L 688.0 1240.0 L 694.0 1239.0 Z",
      "position": {
        "x": 719,
        "y": 1256
      },
      "badgeAnchor": {
        "x": 720.7,
        "y": 1279.09
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t13",
      "name": "Spire Battery",
      "regionId": "artillery-sunspire",
      "adjacencies": [
        "t21"
      ],
      "shape": "M 749.0 231.0 L 755.0 236.0 L 758.0 236.0 L 762.0 239.0 L 769.0 248.0 L 768.0 252.0 L 770.0 254.0 L 770.0 267.0 L 774.0 272.0 L 776.0 269.0 L 777.0 270.0 L 779.0 277.0 L 770.0 282.0 L 756.0 296.0 L 752.0 298.0 L 731.0 278.0 L 731.0 274.0 L 736.0 272.0 L 736.0 268.0 L 734.0 266.0 L 736.0 264.0 L 736.0 245.0 L 734.0 242.0 L 735.0 241.0 L 738.0 244.0 L 741.0 240.0 L 740.0 236.0 L 749.0 235.0 L 750.0 234.0 L 748.0 232.0 Z",
      "position": {
        "x": 752,
        "y": 265
      },
      "badgeAnchor": {
        "x": 755.59,
        "y": 293.01
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t14",
      "name": "Mire Court",
      "adjacencies": [
        "t12",
        "t88",
        "t90",
        "t93",
        "t92"
      ],
      "shape": "M 706.0 1115.0 L 725.0 1138.0 L 725.0 1146.0 L 727.0 1148.0 L 764.0 1146.0 L 800.0 1188.0 L 774.0 1273.0 L 799.0 1298.0 L 793.0 1304.0 L 794.0 1305.0 L 792.0 1308.0 L 771.0 1327.0 L 682.0 1325.0 L 621.0 1255.0 L 623.0 1234.0 L 626.0 1234.0 L 640.0 1222.0 L 722.0 1143.0 L 722.0 1137.0 L 705.0 1116.0 Z M 722.0 1198.0 L 728.0 1199.0 L 735.0 1204.0 L 727.0 1211.0 L 738.0 1222.0 L 738.0 1231.0 L 740.0 1234.0 L 747.0 1239.0 L 751.0 1240.0 L 766.0 1254.0 L 766.0 1281.0 L 731.0 1314.0 L 707.0 1314.0 L 672.0 1279.0 L 672.0 1263.0 L 675.0 1254.0 L 675.0 1248.0 L 677.0 1245.0 L 689.0 1237.0 L 692.0 1237.0 L 701.0 1232.0 L 702.0 1223.0 L 720.0 1207.0 L 721.0 1199.0 Z",
      "position": {
        "x": 722,
        "y": 1232
      },
      "badgeAnchor": {
        "x": 758.62,
        "y": 1184.55
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t15",
      "name": "Iron Court",
      "adjacencies": [
        "t1",
        "t16",
        "t18",
        "t24"
      ],
      "shape": "M 534.0 14.0 L 540.0 18.0 L 538.0 22.0 L 538.0 30.0 L 540.0 32.0 L 539.0 33.0 L 608.0 96.0 L 617.0 106.0 L 619.0 106.0 L 640.0 125.0 L 644.0 129.0 L 644.0 132.0 L 551.0 212.0 L 528.0 234.0 L 528.0 236.0 L 524.0 236.0 L 514.0 246.0 L 513.0 245.0 L 515.0 223.0 L 437.0 121.0 L 433.0 115.0 L 433.0 112.0 L 443.0 103.0 L 446.0 104.0 L 450.0 101.0 L 497.0 62.0 L 505.0 54.0 L 504.0 53.0 L 512.0 46.0 L 513.0 40.0 L 516.0 43.0 L 532.0 30.0 L 533.0 19.0 L 531.0 17.0 L 533.0 15.0 Z M 531.0 54.0 L 535.0 58.0 L 547.0 61.0 L 540.0 68.0 L 548.0 76.0 L 546.0 78.0 L 546.0 88.0 L 549.0 91.0 L 547.0 94.0 L 552.0 100.0 L 552.0 105.0 L 566.0 119.0 L 566.0 124.0 L 551.0 139.0 L 535.0 152.0 L 518.0 152.0 L 490.0 124.0 L 490.0 116.0 L 501.0 107.0 L 499.0 105.0 L 491.0 110.0 L 489.0 107.0 L 486.0 110.0 L 485.0 124.0 L 518.0 157.0 L 536.0 157.0 L 542.0 152.0 L 544.0 152.0 L 551.0 144.0 L 553.0 144.0 L 571.0 124.0 L 570.0 112.0 L 568.0 110.0 L 566.0 111.0 L 557.0 104.0 L 557.0 99.0 L 553.0 93.0 L 555.0 92.0 L 559.0 96.0 L 561.0 95.0 L 564.0 97.0 L 574.0 109.0 L 575.0 143.0 L 542.0 171.0 L 542.0 160.0 L 545.0 157.0 L 543.0 155.0 L 537.0 158.0 L 520.0 158.0 L 514.0 156.0 L 512.0 158.0 L 513.0 171.0 L 500.0 159.0 L 498.0 160.0 L 487.0 151.0 L 487.0 148.0 L 481.0 142.0 L 481.0 119.0 L 483.0 107.0 L 491.0 101.0 L 494.0 98.0 L 494.0 96.0 L 502.0 94.0 L 509.0 88.0 L 510.0 77.0 L 530.0 63.0 L 530.0 55.0 Z",
      "position": {
        "x": 539,
        "y": 133
      },
      "badgeAnchor": {
        "x": 524.24,
        "y": 198.77
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t16",
      "name": "Iron Forge",
      "adjacencies": [
        "t15",
        "t17",
        "t20",
        "t24"
      ],
      "shape": "M 431.0 116.0 L 512.0 222.0 L 460.0 223.0 L 401.0 186.0 L 401.0 141.0 L 430.0 117.0 Z",
      "position": {
        "x": 445,
        "y": 177
      },
      "badgeAnchor": {
        "x": 442.72,
        "y": 178.59
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t17",
      "name": "Iron Flag",
      "regionId": "flag-t17",
      "adjacencies": [
        "t16",
        "t27",
        "t26",
        "t20"
      ],
      "borderDice": {
        "t3": {
          "defend": 5
        },
        "t16": {
          "defend": 5
        },
        "t20": {
          "defend": 5
        },
        "t26": {
          "defend": 5
        },
        "t27": {
          "defend": 5
        }
      },
      "shape": "M 409.0 118.0 L 411.0 119.0 L 409.0 121.0 L 409.0 130.0 L 410.0 131.0 L 413.0 128.0 L 415.0 129.0 L 401.0 141.0 L 401.0 187.0 L 399.0 187.0 L 398.0 172.0 L 399.0 133.0 L 397.0 132.0 L 391.0 137.0 L 391.0 212.0 L 393.0 274.0 L 387.0 276.0 L 314.0 341.0 L 310.0 340.0 L 260.0 312.0 L 255.0 312.0 L 253.0 308.0 L 235.0 298.0 L 230.0 298.0 L 217.0 291.0 L 216.0 280.0 L 220.0 278.0 L 222.0 279.0 L 220.0 281.0 L 220.0 289.0 L 222.0 290.0 L 229.0 284.0 L 232.0 279.0 L 235.0 279.0 L 237.0 277.0 L 240.0 278.0 L 245.0 274.0 L 371.0 167.0 L 371.0 164.0 L 388.0 148.0 L 387.0 139.0 L 380.0 145.0 L 378.0 144.0 L 388.0 134.0 L 392.0 134.0 L 397.0 130.0 L 408.0 119.0 Z",
      "position": {
        "x": 327,
        "y": 257
      },
      "badgeAnchor": {
        "x": 288.91,
        "y": 286.73
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t18",
      "name": "Iron Postern",
      "adjacencies": [
        "t15",
        "t22"
      ],
      "oneWayBorders": [
        "t35"
      ],
      "borderDice": {
        "t22": {
          "defend": 8
        },
        "t35": {
          "attack": 7
        }
      },
      "shape": "M 618.0 181.0 L 620.0 181.0 L 634.0 196.0 L 546.0 279.0 L 528.0 260.0 L 540.0 248.0 L 617.0 182.0 Z",
      "position": {
        "x": 580,
        "y": 229
      },
      "badgeAnchor": {
        "x": 583.3,
        "y": 229.46
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t19",
      "name": "Spire Zenith",
      "adjacencies": [
        "t2",
        "t23",
        "t25",
        "t28"
      ],
      "shape": "M 890.0 179.0 L 907.0 194.0 L 908.0 185.0 L 904.0 181.0 L 905.0 180.0 L 916.0 189.0 L 911.0 193.0 L 913.0 196.0 L 916.0 197.0 L 913.0 200.0 L 912.0 304.0 L 912.0 318.0 L 917.0 325.0 L 915.0 327.0 L 915.0 336.0 L 914.0 337.0 L 910.0 333.0 L 910.0 323.0 L 908.0 321.0 L 858.0 323.0 L 805.0 254.0 L 809.0 249.0 L 827.0 234.0 L 889.0 186.0 L 892.0 183.0 L 889.0 180.0 Z",
      "position": {
        "x": 871,
        "y": 258
      },
      "badgeAnchor": {
        "x": 866.25,
        "y": 260.47
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t20",
      "name": "Iron Anvil",
      "adjacencies": [
        "t16",
        "t24",
        "t26",
        "t17"
      ],
      "shape": "M 399.0 187.0 L 401.0 190.0 L 403.0 189.0 L 410.0 193.0 L 460.0 224.0 L 448.0 272.0 L 404.0 287.0 L 401.0 286.0 L 401.0 259.0 L 399.0 257.0 L 398.0 245.0 L 398.0 188.0 Z",
      "position": {
        "x": 424,
        "y": 240
      },
      "badgeAnchor": {
        "x": 426.09,
        "y": 238.56
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t21",
      "name": "Spire Sally",
      "adjacencies": [
        "t13",
        "t22",
        "t2"
      ],
      "oneWayBorders": [
        "t35"
      ],
      "borderDice": {
        "t22": {
          "defend": 8
        },
        "t35": {
          "attack": 7
        }
      },
      "shape": "M 701.0 183.0 L 703.0 185.0 L 701.0 192.0 L 702.0 195.0 L 716.0 209.0 L 715.0 211.0 L 706.0 202.0 L 705.0 212.0 L 711.0 217.0 L 711.0 221.0 L 736.0 245.0 L 736.0 264.0 L 730.0 269.0 L 728.0 269.0 L 684.0 226.0 L 682.0 227.0 L 673.0 218.0 L 674.0 207.0 L 678.0 205.0 L 680.0 206.0 L 676.0 210.0 L 676.0 217.0 L 678.0 218.0 L 685.0 212.0 L 686.0 208.0 L 689.0 210.0 L 698.0 202.0 L 698.0 194.0 L 696.0 192.0 L 700.0 188.0 L 700.0 184.0 Z",
      "position": {
        "x": 708,
        "y": 233
      },
      "badgeAnchor": {
        "x": 711.84,
        "y": 237.03
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t22",
      "name": "Vault",
      "adjacencies": [
        "t18",
        "t21",
        "t30",
        "t31",
        "t35"
      ],
      "shape": "M 646.0 212.0 L 663.0 229.0 L 663.0 233.0 L 667.0 238.0 L 671.0 239.0 L 720.0 288.0 L 721.0 293.0 L 745.0 317.0 L 745.0 319.0 L 751.0 326.0 L 773.0 349.0 L 724.0 391.0 L 723.0 378.0 L 718.0 374.0 L 715.0 375.0 L 711.0 372.0 L 683.0 372.0 L 670.0 363.0 L 649.0 356.0 L 643.0 357.0 L 640.0 355.0 L 630.0 355.0 L 606.0 371.0 L 565.0 371.0 L 561.0 373.0 L 554.0 366.0 L 528.0 338.0 L 528.0 336.0 L 536.0 329.0 L 535.0 327.0 L 543.0 319.0 L 543.0 314.0 L 546.0 313.0 L 546.0 309.0 L 544.0 307.0 L 547.0 303.0 L 547.0 294.0 L 545.0 292.0 L 540.0 293.0 L 541.0 301.0 L 539.0 303.0 L 536.0 299.0 L 538.0 288.0 L 536.0 284.0 L 538.0 283.0 L 541.0 286.0 L 541.0 290.0 L 547.0 289.0 L 549.0 286.0 L 546.0 283.0 L 547.0 281.0 L 550.0 284.0 L 552.0 284.0 L 553.0 285.0 L 551.0 287.0 L 551.0 293.0 L 552.0 297.0 L 554.0 298.0 L 645.0 213.0 Z",
      "position": {
        "x": 646,
        "y": 312
      },
      "badgeAnchor": {
        "x": 646.67,
        "y": 298.7
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t23",
      "name": "Spire Flag",
      "regionId": "flag-t23",
      "adjacencies": [
        "t19",
        "t37",
        "t28",
        "t32"
      ],
      "borderDice": {
        "t2": {
          "defend": 5
        },
        "t19": {
          "defend": 5
        },
        "t28": {
          "defend": 5
        },
        "t32": {
          "defend": 5
        },
        "t37": {
          "defend": 5
        }
      },
      "shape": "M 925.0 213.0 L 1083.0 367.0 L 1057.0 372.0 L 1056.0 375.0 L 1051.0 376.0 L 1040.0 378.0 L 1030.0 377.0 L 1028.0 380.0 L 1023.0 381.0 L 1012.0 380.0 L 988.0 385.0 L 922.0 318.0 L 922.0 215.0 L 924.0 214.0 Z",
      "position": {
        "x": 982,
        "y": 316
      },
      "badgeAnchor": {
        "x": 1010.27,
        "y": 349.53
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t24",
      "name": "Iron Bellows",
      "adjacencies": [
        "t15",
        "t16",
        "t20",
        "t26"
      ],
      "shape": "M 463.0 224.0 L 513.0 225.0 L 513.0 270.0 L 532.0 291.0 L 531.0 294.0 L 538.0 301.0 L 531.0 308.0 L 529.0 308.0 L 518.0 302.0 L 471.0 283.0 L 467.0 280.0 L 452.0 275.0 L 450.0 273.0 L 450.0 270.0 L 462.0 225.0 Z",
      "position": {
        "x": 489,
        "y": 261
      },
      "badgeAnchor": {
        "x": 484.38,
        "y": 254.19
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t25",
      "name": "Spire Solar",
      "adjacencies": [
        "t2",
        "t19",
        "t28"
      ],
      "shape": "M 771.0 253.0 L 802.0 254.0 L 854.0 321.0 L 853.0 325.0 L 813.0 365.0 L 779.0 327.0 L 760.0 309.0 L 766.0 307.0 L 783.0 291.0 L 782.0 282.0 L 777.0 287.0 L 775.0 286.0 L 783.0 278.0 L 783.0 268.0 L 770.0 254.0 Z",
      "position": {
        "x": 807,
        "y": 308
      },
      "badgeAnchor": {
        "x": 808.47,
        "y": 314.25
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t26",
      "name": "Iron Cinder",
      "adjacencies": [
        "t20",
        "t24",
        "t29",
        "t33",
        "t17"
      ],
      "shape": "M 400.0 257.0 L 400.0 287.0 L 402.0 289.0 L 437.0 279.0 L 443.0 276.0 L 451.0 276.0 L 526.0 308.0 L 529.0 310.0 L 529.0 312.0 L 522.0 316.0 L 486.0 350.0 L 460.0 324.0 L 458.0 325.0 L 451.0 319.0 L 449.0 319.0 L 448.0 325.0 L 478.0 355.0 L 477.0 356.0 L 447.0 327.0 L 446.0 333.0 L 450.0 337.0 L 449.0 338.0 L 443.0 333.0 L 426.0 348.0 L 424.0 347.0 L 428.0 343.0 L 428.0 335.0 L 425.0 333.0 L 429.0 329.0 L 431.0 330.0 L 430.0 337.0 L 432.0 339.0 L 443.0 330.0 L 445.0 320.0 L 444.0 319.0 L 440.0 323.0 L 438.0 322.0 L 446.0 314.0 L 440.0 309.0 L 363.0 376.0 L 322.0 365.0 L 318.0 361.0 L 322.0 357.0 L 322.0 350.0 L 319.0 348.0 L 325.0 342.0 L 327.0 343.0 L 324.0 346.0 L 325.0 355.0 L 332.0 349.0 L 333.0 342.0 L 338.0 347.0 L 382.0 308.0 L 385.0 305.0 L 384.0 303.0 L 396.0 292.0 L 396.0 284.0 L 392.0 283.0 L 398.0 277.0 L 397.0 274.0 L 399.0 272.0 L 399.0 258.0 Z",
      "position": {
        "x": 424,
        "y": 321
      },
      "badgeAnchor": {
        "x": 403.14,
        "y": 316.41
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t27",
      "name": "Iron Slag",
      "adjacencies": [
        "t3",
        "t17",
        "t33",
        "t40"
      ],
      "shape": "M 208.0 308.0 L 285.0 349.0 L 311.0 365.0 L 269.0 411.0 L 262.0 412.0 L 247.0 410.0 L 173.0 336.0 L 201.0 312.0 L 207.0 309.0 Z",
      "position": {
        "x": 241,
        "y": 360
      },
      "badgeAnchor": {
        "x": 242.69,
        "y": 360.35
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t28",
      "name": "Spire Flare",
      "adjacencies": [
        "t19",
        "t25",
        "t32",
        "t36",
        "t23"
      ],
      "shape": "M 902.0 322.0 L 910.0 323.0 L 911.0 335.0 L 932.0 357.0 L 885.0 397.0 L 883.0 397.0 L 850.0 362.0 L 848.0 364.0 L 838.0 363.0 L 822.0 375.0 L 816.0 369.0 L 814.0 365.0 L 854.0 325.0 L 901.0 323.0 Z",
      "position": {
        "x": 878,
        "y": 354
      },
      "badgeAnchor": {
        "x": 885.91,
        "y": 355.98
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t29",
      "name": "Iron Barbican",
      "adjacencies": [
        "t26",
        "t33",
        "t34"
      ],
      "borderDice": {
        "t34": {
          "defend": 7
        }
      },
      "shape": "M 442.0 334.0 L 444.0 334.0 L 450.0 340.0 L 452.0 339.0 L 460.0 347.0 L 459.0 349.0 L 462.0 349.0 L 473.0 360.0 L 483.0 352.0 L 485.0 353.0 L 475.0 362.0 L 475.0 364.0 L 471.0 364.0 L 469.0 366.0 L 470.0 367.0 L 468.0 369.0 L 470.0 371.0 L 476.0 372.0 L 473.0 376.0 L 473.0 383.0 L 475.0 385.0 L 472.0 389.0 L 460.0 401.0 L 456.0 404.0 L 454.0 403.0 L 457.0 400.0 L 458.0 396.0 L 460.0 397.0 L 464.0 394.0 L 464.0 387.0 L 459.0 387.0 L 470.0 374.0 L 465.0 370.0 L 463.0 371.0 L 460.0 374.0 L 461.0 375.0 L 459.0 379.0 L 455.0 383.0 L 453.0 382.0 L 448.0 386.0 L 420.0 411.0 L 412.0 421.0 L 411.0 420.0 L 408.0 424.0 L 407.0 423.0 L 400.0 432.0 L 398.0 431.0 L 392.0 436.0 L 385.0 443.0 L 386.0 445.0 L 382.0 448.0 L 371.0 436.0 L 372.0 435.0 L 366.0 427.0 L 352.0 413.0 L 350.0 414.0 L 344.0 407.0 L 345.0 404.0 L 351.0 410.0 L 361.0 401.0 L 362.0 396.0 L 365.0 398.0 L 378.0 386.0 L 381.0 387.0 L 395.0 375.0 L 394.0 373.0 L 397.0 370.0 L 398.0 371.0 L 403.0 365.0 L 404.0 366.0 L 409.0 363.0 L 416.0 355.0 L 424.0 350.0 L 441.0 335.0 Z",
      "position": {
        "x": 413,
        "y": 388
      },
      "badgeAnchor": {
        "x": 417.71,
        "y": 385.38
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t30",
      "name": "Rise",
      "adjacencies": [
        "t22",
        "t34"
      ],
      "shape": "M 525.0 338.0 L 558.0 372.0 L 564.0 374.0 L 561.0 376.0 L 560.0 396.0 L 557.0 398.0 L 555.0 397.0 L 550.0 404.0 L 548.0 403.0 L 534.0 416.0 L 492.0 371.0 L 524.0 339.0 Z",
      "position": {
        "x": 529,
        "y": 376
      },
      "badgeAnchor": {
        "x": 533.63,
        "y": 380.66
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t31",
      "name": "Hollow",
      "adjacencies": [
        "t22",
        "t38"
      ],
      "shape": "M 774.0 350.0 L 808.0 388.0 L 810.0 387.0 L 813.0 390.0 L 814.0 389.0 L 814.0 381.0 L 811.0 378.0 L 812.0 376.0 L 815.0 379.0 L 819.0 379.0 L 817.0 381.0 L 823.0 389.0 L 828.0 384.0 L 831.0 388.0 L 834.0 389.0 L 832.0 392.0 L 829.0 389.0 L 827.0 389.0 L 823.0 393.0 L 823.0 401.0 L 831.0 410.0 L 830.0 411.0 L 820.0 400.0 L 817.0 399.0 L 769.0 441.0 L 765.0 441.0 L 758.0 434.0 L 759.0 432.0 L 723.0 394.0 L 773.0 351.0 Z",
      "position": {
        "x": 772,
        "y": 396
      },
      "badgeAnchor": {
        "x": 769.83,
        "y": 396.92
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t32",
      "name": "Spire Glare",
      "adjacencies": [
        "t28",
        "t36",
        "t39",
        "t23"
      ],
      "shape": "M 933.0 358.0 L 980.0 406.0 L 928.0 450.0 L 927.0 442.0 L 896.0 411.0 L 886.0 400.0 L 886.0 398.0 L 932.0 359.0 Z",
      "position": {
        "x": 932,
        "y": 402
      },
      "badgeAnchor": {
        "x": 931.53,
        "y": 402.56
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t33",
      "name": "Iron Quench",
      "adjacencies": [
        "t26",
        "t27",
        "t29",
        "t40"
      ],
      "shape": "M 314.0 365.0 L 319.0 365.0 L 358.0 376.0 L 361.0 378.0 L 335.0 401.0 L 337.0 403.0 L 336.0 417.0 L 337.0 423.0 L 341.0 427.0 L 339.0 429.0 L 359.0 445.0 L 368.0 455.0 L 364.0 459.0 L 362.0 458.0 L 359.0 463.0 L 358.0 462.0 L 353.0 466.0 L 269.0 413.0 L 313.0 366.0 Z",
      "position": {
        "x": 319,
        "y": 410
      },
      "badgeAnchor": {
        "x": 313.64,
        "y": 401.55
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t34",
      "name": "Span",
      "adjacencies": [
        "t29",
        "t30",
        "t45"
      ],
      "shape": "M 487.0 359.0 L 489.0 360.0 L 482.0 367.0 L 482.0 374.0 L 483.0 375.0 L 489.0 370.0 L 532.0 417.0 L 449.0 489.0 L 439.0 501.0 L 437.0 500.0 L 433.0 503.0 L 395.0 463.0 L 392.0 458.0 L 396.0 454.0 L 396.0 447.0 L 398.0 447.0 L 399.0 452.0 L 405.0 446.0 L 408.0 447.0 L 460.0 401.0 L 476.0 385.0 L 475.0 383.0 L 479.0 379.0 L 480.0 374.0 L 480.0 370.0 L 478.0 368.0 L 486.0 360.0 Z",
      "position": {
        "x": 462,
        "y": 437
      },
      "badgeAnchor": {
        "x": 456.93,
        "y": 444.61
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t35",
      "name": "North Keep",
      "adjacencies": [
        "t22",
        "t44"
      ],
      "borderDice": {
        "t6": {
          "defend": 7
        },
        "t18": {
          "defend": 7
        },
        "t21": {
          "defend": 7
        },
        "t22": {
          "defend": 7
        },
        "t44": {
          "defend": 7
        }
      },
      "shape": "M 637.0 360.0 L 652.0 366.0 L 649.0 367.0 L 641.0 364.0 L 640.0 371.0 L 642.0 373.0 L 654.0 375.0 L 665.0 381.0 L 667.0 379.0 L 670.0 384.0 L 669.0 385.0 L 676.0 390.0 L 679.0 388.0 L 680.0 378.0 L 712.0 380.0 L 714.0 384.0 L 711.0 418.0 L 708.0 421.0 L 634.0 420.0 L 632.0 422.0 L 629.0 422.0 L 628.0 419.0 L 623.0 420.0 L 579.0 417.0 L 566.0 420.0 L 566.0 408.0 L 564.0 406.0 L 567.0 401.0 L 568.0 380.0 L 570.0 378.0 L 609.0 378.0 L 611.0 388.0 L 620.0 382.0 L 623.0 378.0 L 625.0 379.0 L 636.0 372.0 L 636.0 365.0 L 630.0 365.0 L 636.0 361.0 Z",
      "position": {
        "x": 639,
        "y": 400
      },
      "badgeAnchor": {
        "x": 635.49,
        "y": 401.57
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t36",
      "name": "Spire Barbican",
      "adjacencies": [
        "t28",
        "t32",
        "t38",
        "t39"
      ],
      "borderDice": {
        "t38": {
          "defend": 7
        }
      },
      "shape": "M 844.0 369.0 L 848.0 372.0 L 847.0 381.0 L 850.0 384.0 L 849.0 385.0 L 851.0 388.0 L 907.0 448.0 L 896.0 458.0 L 896.0 461.0 L 893.0 461.0 L 893.0 456.0 L 852.0 411.0 L 839.0 398.0 L 838.0 399.0 L 833.0 394.0 L 835.0 391.0 L 832.0 388.0 L 843.0 380.0 L 843.0 370.0 Z",
      "position": {
        "x": 869,
        "y": 418
      },
      "badgeAnchor": {
        "x": 877.7,
        "y": 427.94
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t37",
      "name": "Spire Halo",
      "adjacencies": [
        "t23",
        "t39",
        "t41"
      ],
      "shape": "M 1082.0 389.0 L 1087.0 389.0 L 1089.0 391.0 L 1091.0 389.0 L 1112.0 411.0 L 1085.0 457.0 L 1080.0 463.0 L 1025.0 467.0 L 1001.0 429.0 L 989.0 407.0 L 990.0 406.0 L 992.0 408.0 L 995.0 405.0 L 1009.0 402.0 L 1081.0 390.0 Z",
      "position": {
        "x": 1052,
        "y": 426
      },
      "badgeAnchor": {
        "x": 1060.11,
        "y": 429.22
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t38",
      "name": "Gully",
      "adjacencies": [
        "t31",
        "t36",
        "t47"
      ],
      "shape": "M 819.0 400.0 L 888.0 474.0 L 890.0 472.0 L 890.0 466.0 L 886.0 461.0 L 887.0 460.0 L 890.0 463.0 L 893.0 461.0 L 894.0 462.0 L 894.0 469.0 L 901.0 479.0 L 900.0 490.0 L 899.0 491.0 L 891.0 482.0 L 889.0 483.0 L 843.0 522.0 L 769.0 443.0 L 818.0 401.0 Z",
      "position": {
        "x": 832,
        "y": 461
      },
      "badgeAnchor": {
        "x": 832.94,
        "y": 462.91
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t39",
      "name": "Spire Ray",
      "adjacencies": [
        "t32",
        "t36",
        "t37",
        "t46"
      ],
      "shape": "M 982.0 407.0 L 986.0 407.0 L 988.0 409.0 L 1023.0 467.0 L 1019.0 470.0 L 1015.0 470.0 L 1002.0 475.0 L 974.0 482.0 L 964.0 486.0 L 960.0 486.0 L 941.0 493.0 L 931.0 495.0 L 929.0 497.0 L 912.0 479.0 L 911.0 477.0 L 927.0 462.0 L 927.0 453.0 L 981.0 408.0 Z",
      "position": {
        "x": 967,
        "y": 456
      },
      "badgeAnchor": {
        "x": 975.75,
        "y": 450.59
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t40",
      "name": "Iron Ingot",
      "adjacencies": [
        "t3",
        "t27",
        "t33"
      ],
      "shape": "M 247.0 411.0 L 269.0 415.0 L 345.0 462.0 L 351.0 467.0 L 301.0 513.0 L 290.0 512.0 L 284.0 507.0 L 282.0 508.0 L 277.0 503.0 L 276.0 507.0 L 282.0 512.0 L 285.0 517.0 L 285.0 520.0 L 265.0 538.0 L 261.0 540.0 L 244.0 524.0 L 244.0 522.0 L 238.0 516.0 L 241.0 510.0 L 241.0 506.0 L 239.0 504.0 L 232.0 508.0 L 230.0 506.0 L 227.0 507.0 L 227.0 505.0 L 223.0 501.0 L 221.0 501.0 L 212.0 509.0 L 210.0 508.0 L 218.0 500.0 L 223.0 498.0 L 246.0 412.0 Z M 255.0 475.0 L 263.0 477.0 L 267.0 476.0 L 267.0 478.0 L 273.0 485.0 L 273.0 494.0 L 270.0 497.0 L 272.0 499.0 L 273.0 509.0 L 278.0 514.0 L 280.0 519.0 L 262.0 535.0 L 256.0 531.0 L 242.0 516.0 L 242.0 513.0 L 245.0 510.0 L 244.0 498.0 L 246.0 495.0 L 244.0 492.0 L 247.0 489.0 L 245.0 485.0 L 254.0 476.0 Z",
      "position": {
        "x": 280,
        "y": 465
      },
      "badgeAnchor": {
        "x": 283.15,
        "y": 461.37
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t41",
      "name": "Spire Court",
      "adjacencies": [
        "t5",
        "t37",
        "t46",
        "t54"
      ],
      "shape": "M 1113.0 413.0 L 1166.0 467.0 L 1166.0 470.0 L 1136.0 501.0 L 1137.0 503.0 L 1135.0 518.0 L 1139.0 524.0 L 1138.0 526.0 L 1136.0 524.0 L 1135.0 525.0 L 1135.0 538.0 L 1157.0 560.0 L 1162.0 558.0 L 1162.0 551.0 L 1165.0 551.0 L 1166.0 576.0 L 1164.0 578.0 L 1163.0 577.0 L 1098.0 643.0 L 1085.0 632.0 L 1086.0 630.0 L 1082.0 626.0 L 1080.0 627.0 L 1075.0 623.0 L 1076.0 621.0 L 1073.0 617.0 L 1067.0 611.0 L 1065.0 612.0 L 1057.0 604.0 L 1058.0 602.0 L 1055.0 599.0 L 1052.0 599.0 L 1053.0 597.0 L 1051.0 594.0 L 1046.0 589.0 L 1044.0 590.0 L 1042.0 588.0 L 1040.0 585.0 L 1041.0 583.0 L 1002.0 542.0 L 1020.0 525.0 L 1019.0 520.0 L 1025.0 470.0 L 1029.0 468.0 L 1082.0 464.0 L 1112.0 414.0 Z M 1080.0 482.0 L 1083.0 482.0 L 1084.0 486.0 L 1087.0 489.0 L 1091.0 489.0 L 1099.0 493.0 L 1093.0 496.0 L 1085.0 504.0 L 1100.0 518.0 L 1099.0 530.0 L 1104.0 536.0 L 1105.0 544.0 L 1116.0 554.0 L 1116.0 558.0 L 1091.0 581.0 L 1075.0 581.0 L 1050.0 555.0 L 1050.0 549.0 L 1055.0 545.0 L 1053.0 543.0 L 1050.0 544.0 L 1048.0 542.0 L 1046.0 544.0 L 1046.0 556.0 L 1071.0 582.0 L 1071.0 594.0 L 1066.0 590.0 L 1065.0 591.0 L 1062.0 588.0 L 1063.0 586.0 L 1055.0 577.0 L 1046.0 568.0 L 1045.0 569.0 L 1043.0 567.0 L 1043.0 560.0 L 1052.0 568.0 L 1054.0 566.0 L 1044.0 555.0 L 1044.0 542.0 L 1047.0 539.0 L 1047.0 537.0 L 1055.0 532.0 L 1056.0 533.0 L 1061.0 528.0 L 1062.0 530.0 L 1055.0 537.0 L 1055.0 541.0 L 1057.0 543.0 L 1060.0 540.0 L 1061.0 536.0 L 1067.0 530.0 L 1067.0 515.0 L 1080.0 505.0 L 1080.0 483.0 Z M 1107.0 533.0 L 1109.0 535.0 L 1115.0 535.0 L 1124.0 543.0 L 1126.0 545.0 L 1127.0 551.0 L 1127.0 572.0 L 1124.0 573.0 L 1105.0 592.0 L 1102.0 591.0 L 1096.0 597.0 L 1095.0 590.0 L 1097.0 587.0 L 1094.0 584.0 L 1121.0 559.0 L 1121.0 547.0 L 1119.0 545.0 L 1116.0 549.0 L 1109.0 542.0 L 1110.0 537.0 L 1107.0 534.0 Z",
      "position": {
        "x": 1093,
        "y": 522
      },
      "badgeAnchor": {
        "x": 1121.3,
        "y": 466.06
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t42",
      "name": "Dawn Flag",
      "regionId": "flag-t42",
      "adjacencies": [
        "t50",
        "t44",
        "t56"
      ],
      "borderDice": {
        "t6": {
          "defend": 5
        },
        "t44": {
          "defend": 5
        },
        "t50": {
          "defend": 5
        },
        "t56": {
          "defend": 5
        }
      },
      "shape": "M 720.0 404.0 L 737.0 420.0 L 736.0 422.0 L 724.0 410.0 L 724.0 419.0 L 740.0 435.0 L 741.0 427.0 L 742.0 426.0 L 745.0 429.0 L 743.0 431.0 L 743.0 442.0 L 800.0 501.0 L 883.0 594.0 L 791.0 595.0 L 723.0 518.0 L 712.0 507.0 L 710.0 507.0 L 709.0 505.0 L 719.0 405.0 Z",
      "position": {
        "x": 779,
        "y": 524
      },
      "badgeAnchor": {
        "x": 804.95,
        "y": 551.11
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t43",
      "name": "Frost Flag",
      "regionId": "flag-t43",
      "adjacencies": [
        "t48",
        "t44",
        "t55"
      ],
      "borderDice": {
        "t6": {
          "defend": 5
        },
        "t44": {
          "defend": 5
        },
        "t48": {
          "defend": 5
        },
        "t55": {
          "defend": 5
        }
      },
      "shape": "M 558.0 417.0 L 559.0 426.0 L 557.0 431.0 L 553.0 495.0 L 549.0 499.0 L 547.0 498.0 L 544.0 500.0 L 478.0 557.0 L 419.0 547.0 L 414.0 546.0 L 413.0 544.0 L 461.0 504.0 L 477.0 486.0 L 481.0 483.0 L 484.0 484.0 L 554.0 423.0 L 555.0 424.0 L 557.0 418.0 Z",
      "position": {
        "x": 498,
        "y": 501
      },
      "badgeAnchor": {
        "x": 515.62,
        "y": 491.52
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t44",
      "name": "Bank",
      "adjacencies": [
        "t48",
        "t50",
        "t35",
        "t42",
        "t43"
      ],
      "shape": "M 566.0 426.0 L 580.0 428.0 L 584.0 427.0 L 584.0 435.0 L 586.0 438.0 L 601.0 439.0 L 604.0 439.0 L 606.0 437.0 L 606.0 429.0 L 608.0 427.0 L 631.0 429.0 L 634.0 428.0 L 639.0 430.0 L 635.0 432.0 L 635.0 436.0 L 637.0 439.0 L 656.0 440.0 L 658.0 443.0 L 705.0 443.0 L 708.0 430.0 L 709.0 442.0 L 707.0 449.0 L 707.0 461.0 L 702.0 505.0 L 703.0 509.0 L 709.0 516.0 L 707.0 518.0 L 707.0 527.0 L 710.0 531.0 L 709.0 532.0 L 703.0 526.0 L 701.0 516.0 L 698.0 513.0 L 696.0 513.0 L 632.0 539.0 L 628.0 539.0 L 562.0 495.0 L 560.0 493.0 L 560.0 489.0 L 564.0 445.0 L 563.0 434.0 L 565.0 432.0 L 565.0 427.0 Z",
      "position": {
        "x": 634,
        "y": 481
      },
      "badgeAnchor": {
        "x": 632.22,
        "y": 479.19
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t45",
      "name": "Bluff",
      "adjacencies": [
        "t34",
        "t49"
      ],
      "shape": "M 390.0 461.0 L 432.0 504.0 L 391.0 540.0 L 389.0 540.0 L 350.0 498.0 L 388.0 465.0 L 389.0 462.0 Z",
      "position": {
        "x": 390,
        "y": 501
      },
      "badgeAnchor": {
        "x": 389.72,
        "y": 499.27
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t46",
      "name": "Spire Beacon",
      "adjacencies": [
        "t39",
        "t41"
      ],
      "shape": "M 1021.0 471.0 L 1023.0 472.0 L 1023.0 479.0 L 1017.0 524.0 L 1001.0 540.0 L 1007.0 547.0 L 1005.0 548.0 L 1000.0 543.0 L 995.0 542.0 L 977.0 549.0 L 931.0 499.0 L 936.0 496.0 L 1020.0 472.0 Z",
      "position": {
        "x": 984,
        "y": 509
      },
      "badgeAnchor": {
        "x": 984.19,
        "y": 513.66
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t47",
      "name": "Crag",
      "adjacencies": [
        "t38",
        "t52"
      ],
      "shape": "M 891.0 484.0 L 904.0 496.0 L 945.0 541.0 L 898.0 582.0 L 896.0 581.0 L 845.0 524.0 L 890.0 485.0 Z",
      "position": {
        "x": 894,
        "y": 532
      },
      "badgeAnchor": {
        "x": 896.56,
        "y": 534.53
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t48",
      "name": "Dell",
      "adjacencies": [
        "t6",
        "t44",
        "t50",
        "t55",
        "t59",
        "t43"
      ],
      "shape": "M 561.0 493.0 L 565.0 499.0 L 627.0 540.0 L 628.0 546.0 L 626.0 568.0 L 611.0 555.0 L 607.0 556.0 L 554.0 600.0 L 563.0 610.0 L 560.0 613.0 L 560.0 645.0 L 558.0 648.0 L 556.0 662.0 L 554.0 664.0 L 553.0 663.0 L 555.0 653.0 L 554.0 650.0 L 546.0 657.0 L 541.0 658.0 L 539.0 656.0 L 503.0 646.0 L 501.0 644.0 L 475.0 581.0 L 482.0 580.0 L 556.0 516.0 L 556.0 506.0 L 554.0 505.0 L 551.0 508.0 L 549.0 507.0 L 559.0 498.0 L 560.0 494.0 Z",
      "position": {
        "x": 545,
        "y": 578
      },
      "badgeAnchor": {
        "x": 520.42,
        "y": 591.86
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t49",
      "name": "Knoll",
      "adjacencies": [
        "t45",
        "t51",
        "t53",
        "t58",
        "t65"
      ],
      "shape": "M 347.0 499.0 L 390.0 542.0 L 385.0 543.0 L 348.0 574.0 L 349.0 575.0 L 347.0 577.0 L 344.0 617.0 L 336.0 622.0 L 321.0 636.0 L 322.0 646.0 L 319.0 680.0 L 323.0 686.0 L 320.0 690.0 L 321.0 696.0 L 319.0 700.0 L 332.0 715.0 L 339.0 722.0 L 340.0 721.0 L 356.0 738.0 L 358.0 736.0 L 357.0 728.0 L 361.0 728.0 L 362.0 730.0 L 360.0 732.0 L 362.0 737.0 L 360.0 743.0 L 361.0 747.0 L 364.0 748.0 L 363.0 753.0 L 365.0 755.0 L 365.0 758.0 L 363.0 760.0 L 363.0 769.0 L 369.0 777.0 L 368.0 778.0 L 363.0 773.0 L 309.0 825.0 L 305.0 821.0 L 306.0 819.0 L 304.0 816.0 L 293.0 807.0 L 294.0 805.0 L 256.0 760.0 L 279.0 739.0 L 279.0 714.0 L 249.0 682.0 L 246.0 682.0 L 238.0 673.0 L 238.0 669.0 L 219.0 648.0 L 203.0 634.0 L 192.0 621.0 L 193.0 618.0 L 199.0 614.0 L 200.0 615.0 L 195.0 621.0 L 199.0 625.0 L 201.0 625.0 L 211.0 617.0 L 217.0 611.0 L 217.0 603.0 L 215.0 601.0 L 224.0 595.0 L 226.0 596.0 L 226.0 606.0 L 228.0 606.0 L 229.0 596.0 L 227.0 594.0 L 229.0 592.0 L 231.0 573.0 L 233.0 571.0 L 236.0 573.0 L 234.0 575.0 L 234.0 585.0 L 239.0 586.0 L 260.0 568.0 L 280.0 550.0 L 279.0 548.0 L 289.0 538.0 L 289.0 529.0 L 285.0 528.0 L 290.0 521.0 L 296.0 524.0 L 300.0 524.0 L 303.0 521.0 L 305.0 522.0 L 302.0 525.0 L 303.0 536.0 L 314.0 526.0 L 315.0 516.0 L 312.0 514.0 L 316.0 510.0 L 318.0 511.0 L 317.0 522.0 L 320.0 524.0 L 346.0 500.0 Z",
      "position": {
        "x": 298,
        "y": 652
      },
      "badgeAnchor": {
        "x": 270.53,
        "y": 638.75
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t50",
      "name": "Drift",
      "adjacencies": [
        "t6",
        "t44",
        "t48",
        "t56",
        "t61",
        "t42"
      ],
      "shape": "M 698.0 514.0 L 701.0 516.0 L 703.0 526.0 L 710.0 534.0 L 781.0 613.0 L 784.0 616.0 L 791.0 618.0 L 762.0 699.0 L 760.0 701.0 L 757.0 701.0 L 697.0 689.0 L 693.0 690.0 L 693.0 678.0 L 663.0 651.0 L 661.0 652.0 L 663.0 659.0 L 662.0 664.0 L 660.0 662.0 L 657.0 646.0 L 657.0 617.0 L 654.0 614.0 L 665.0 604.0 L 664.0 600.0 L 626.0 567.0 L 627.0 558.0 L 629.0 554.0 L 629.0 544.0 L 632.0 540.0 L 697.0 515.0 Z",
      "position": {
        "x": 709,
        "y": 610
      },
      "badgeAnchor": {
        "x": 708.7,
        "y": 614.93
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t51",
      "name": "Iron Sally",
      "adjacencies": [
        "t49",
        "t4",
        "t3"
      ],
      "oneWayBorders": [
        "t53",
        "t40"
      ],
      "borderDice": {
        "t49": {
          "defend": 8
        },
        "t53": {
          "attack": 7
        }
      },
      "shape": "M 224.0 524.0 L 229.0 529.0 L 231.0 529.0 L 232.0 532.0 L 248.0 548.0 L 251.0 549.0 L 248.0 552.0 L 246.0 551.0 L 231.0 565.0 L 227.0 564.0 L 225.0 566.0 L 221.0 590.0 L 217.0 590.0 L 208.0 597.0 L 203.0 589.0 L 180.0 565.0 L 223.0 525.0 Z",
      "position": {
        "x": 213,
        "y": 559
      },
      "badgeAnchor": {
        "x": 216.58,
        "y": 555.66
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t52",
      "name": "Moor",
      "adjacencies": [
        "t47",
        "t54",
        "t62",
        "t66",
        "t57"
      ],
      "shape": "M 946.0 543.0 L 974.0 571.0 L 974.0 588.0 L 979.0 594.0 L 978.0 597.0 L 1036.0 664.0 L 1046.0 672.0 L 1045.0 674.0 L 1072.0 705.0 L 1041.0 733.0 L 1026.0 750.0 L 1033.0 752.0 L 1044.0 742.0 L 1046.0 743.0 L 1035.0 753.0 L 1036.0 758.0 L 1038.0 760.0 L 1042.0 756.0 L 1044.0 757.0 L 1039.0 762.0 L 1040.0 786.0 L 1042.0 788.0 L 1040.0 803.0 L 1037.0 803.0 L 1021.0 818.0 L 1001.0 800.0 L 1004.0 792.0 L 1004.0 786.0 L 1002.0 785.0 L 996.0 791.0 L 995.0 798.0 L 945.0 846.0 L 945.0 844.0 L 938.0 834.0 L 902.0 787.0 L 908.0 782.0 L 906.0 780.0 L 912.0 774.0 L 911.0 762.0 L 918.0 755.0 L 920.0 756.0 L 915.0 761.0 L 914.0 766.0 L 916.0 771.0 L 932.0 756.0 L 932.0 745.0 L 924.0 753.0 L 922.0 752.0 L 934.0 739.0 L 937.0 695.0 L 933.0 687.0 L 924.0 678.0 L 922.0 678.0 L 924.0 649.0 L 923.0 646.0 L 925.0 633.0 L 924.0 630.0 L 918.0 623.0 L 918.0 619.0 L 906.0 604.0 L 902.0 600.0 L 901.0 601.0 L 898.0 599.0 L 900.0 597.0 L 898.0 594.0 L 899.0 584.0 L 945.0 544.0 Z M 1017.0 754.0 L 1021.0 756.0 L 1029.0 754.0 L 1036.0 764.0 L 1035.0 767.0 L 1037.0 769.0 L 1037.0 773.0 L 1034.0 776.0 L 1036.0 779.0 L 1037.0 798.0 L 1022.0 813.0 L 1020.0 813.0 L 1006.0 799.0 L 1008.0 796.0 L 1008.0 778.0 L 1010.0 776.0 L 1008.0 774.0 L 1008.0 765.0 L 1017.0 755.0 Z",
      "position": {
        "x": 972,
        "y": 696
      },
      "badgeAnchor": {
        "x": 993.69,
        "y": 699.02
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t53",
      "name": "West Keep",
      "adjacencies": [
        "t49",
        "t55"
      ],
      "borderDice": {
        "t6": {
          "defend": 7
        },
        "t49": {
          "defend": 7
        },
        "t51": {
          "defend": 7
        },
        "t55": {
          "defend": 7
        },
        "t58": {
          "defend": 7
        }
      },
      "shape": "M 393.0 549.0 L 395.0 551.0 L 400.0 552.0 L 412.0 554.0 L 417.0 553.0 L 418.0 557.0 L 415.0 569.0 L 416.0 570.0 L 414.0 576.0 L 412.0 596.0 L 410.0 598.0 L 411.0 599.0 L 409.0 603.0 L 410.0 607.0 L 404.0 639.0 L 405.0 641.0 L 403.0 644.0 L 404.0 646.0 L 401.0 658.0 L 401.0 668.0 L 399.0 674.0 L 398.0 688.0 L 396.0 691.0 L 397.0 693.0 L 395.0 700.0 L 393.0 724.0 L 391.0 730.0 L 390.0 731.0 L 388.0 727.0 L 371.0 727.0 L 337.0 688.0 L 330.0 681.0 L 329.0 682.0 L 327.0 680.0 L 327.0 666.0 L 330.0 639.0 L 332.0 639.0 L 333.0 648.0 L 350.0 633.0 L 349.0 629.0 L 351.0 625.0 L 347.0 624.0 L 351.0 619.0 L 352.0 613.0 L 354.0 580.0 L 356.0 578.0 L 357.0 579.0 L 357.0 587.0 L 360.0 587.0 L 370.0 578.0 L 371.0 572.0 L 373.0 576.0 L 389.0 563.0 L 388.0 560.0 L 390.0 558.0 L 390.0 555.0 L 386.0 554.0 L 392.0 550.0 Z",
      "position": {
        "x": 374,
        "y": 643
      },
      "badgeAnchor": {
        "x": 371.56,
        "y": 649.46
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t54",
      "name": "Spire Postern",
      "adjacencies": [
        "t41",
        "t52"
      ],
      "oneWayBorders": [
        "t57"
      ],
      "borderDice": {
        "t52": {
          "defend": 8
        },
        "t57": {
          "attack": 7
        }
      },
      "shape": "M 995.0 565.0 L 998.0 565.0 L 1013.0 580.0 L 1073.0 645.0 L 1084.0 659.0 L 1070.0 673.0 L 1065.0 669.0 L 994.0 586.0 L 987.0 579.0 L 986.0 580.0 L 984.0 578.0 L 982.0 571.0 L 994.0 566.0 Z",
      "position": {
        "x": 1034,
        "y": 618
      },
      "badgeAnchor": {
        "x": 1035.79,
        "y": 617.66
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t55",
      "name": "Glen",
      "adjacencies": [
        "t48",
        "t53",
        "t59",
        "t63",
        "t43"
      ],
      "shape": "M 519.0 533.0 L 521.0 542.0 L 523.0 544.0 L 482.0 580.0 L 476.0 580.0 L 474.0 582.0 L 501.0 646.0 L 452.0 729.0 L 450.0 734.0 L 453.0 738.0 L 451.0 739.0 L 449.0 737.0 L 404.0 733.0 L 399.0 731.0 L 400.0 730.0 L 397.0 728.0 L 398.0 726.0 L 396.0 724.0 L 398.0 722.0 L 397.0 721.0 L 399.0 715.0 L 402.0 684.0 L 404.0 679.0 L 403.0 676.0 L 406.0 666.0 L 408.0 642.0 L 411.0 631.0 L 417.0 588.0 L 419.0 583.0 L 422.0 557.0 L 427.0 556.0 L 449.0 561.0 L 462.0 562.0 L 465.0 564.0 L 464.0 565.0 L 450.0 563.0 L 449.0 571.0 L 459.0 572.0 L 472.0 576.0 L 474.0 575.0 L 474.0 568.0 L 471.0 566.0 L 480.0 565.0 L 485.0 562.0 L 486.0 563.0 L 483.0 566.0 L 484.0 575.0 L 500.0 561.0 L 501.0 554.0 L 504.0 558.0 L 518.0 546.0 L 518.0 538.0 L 514.0 537.0 L 518.0 534.0 Z",
      "position": {
        "x": 445,
        "y": 650
      },
      "badgeAnchor": {
        "x": 449.86,
        "y": 651.91
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t56",
      "name": "Loft",
      "adjacencies": [
        "t50",
        "t57",
        "t61",
        "t67",
        "t42"
      ],
      "shape": "M 782.0 598.0 L 787.0 603.0 L 857.0 604.0 L 857.0 683.0 L 860.0 777.0 L 858.0 778.0 L 856.0 774.0 L 848.0 776.0 L 836.0 776.0 L 784.0 771.0 L 787.0 768.0 L 763.0 705.0 L 764.0 697.0 L 793.0 620.0 L 792.0 617.0 L 786.0 617.0 L 783.0 615.0 L 782.0 613.0 L 784.0 611.0 L 784.0 603.0 L 781.0 599.0 Z",
      "position": {
        "x": 816,
        "y": 694
      },
      "badgeAnchor": {
        "x": 809.98,
        "y": 711.16
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t57",
      "name": "East Keep",
      "adjacencies": [
        "t56",
        "t52"
      ],
      "borderDice": {
        "t6": {
          "defend": 7
        },
        "t52": {
          "defend": 7
        },
        "t54": {
          "defend": 7
        },
        "t56": {
          "defend": 7
        },
        "t62": {
          "defend": 7
        }
      },
      "shape": "M 892.0 600.0 L 900.0 610.0 L 899.0 612.0 L 894.0 607.0 L 893.0 608.0 L 893.0 616.0 L 894.0 617.0 L 895.0 614.0 L 897.0 614.0 L 897.0 621.0 L 901.0 625.0 L 900.0 628.0 L 908.0 636.0 L 909.0 635.0 L 912.0 638.0 L 915.0 635.0 L 913.0 629.0 L 914.0 628.0 L 917.0 631.0 L 915.0 664.0 L 915.0 679.0 L 917.0 682.0 L 914.0 687.0 L 916.0 691.0 L 914.0 694.0 L 924.0 702.0 L 927.0 700.0 L 927.0 696.0 L 930.0 696.0 L 926.0 739.0 L 918.0 743.0 L 894.0 765.0 L 884.0 775.0 L 885.0 776.0 L 882.0 779.0 L 872.0 779.0 L 864.0 777.0 L 866.0 773.0 L 864.0 771.0 L 865.0 761.0 L 863.0 742.0 L 866.0 739.0 L 866.0 737.0 L 863.0 735.0 L 862.0 710.0 L 862.0 607.0 L 865.0 603.0 L 889.0 603.0 L 891.0 601.0 Z",
      "position": {
        "x": 889,
        "y": 693
      },
      "badgeAnchor": {
        "x": 894.94,
        "y": 711.16
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t58",
      "name": "Stone Postern",
      "adjacencies": [
        "t49",
        "t60"
      ],
      "oneWayBorders": [
        "t53"
      ],
      "borderDice": {
        "t49": {
          "defend": 8
        },
        "t53": {
          "attack": 7
        }
      },
      "shape": "M 186.0 640.0 L 262.0 724.0 L 246.0 739.0 L 244.0 739.0 L 236.0 731.0 L 169.0 653.0 L 179.0 644.0 L 185.0 641.0 Z",
      "position": {
        "x": 215,
        "y": 689
      },
      "badgeAnchor": {
        "x": 214.05,
        "y": 687.95
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t59",
      "name": "Notch",
      "adjacencies": [
        "t48",
        "t55",
        "t61",
        "t70",
        "t6",
        "t63"
      ],
      "shape": "M 502.0 648.0 L 539.0 658.0 L 542.0 660.0 L 525.0 675.0 L 524.0 692.0 L 526.0 695.0 L 524.0 697.0 L 524.0 712.0 L 531.0 719.0 L 583.0 766.0 L 585.0 764.0 L 585.0 750.0 L 607.0 752.0 L 587.0 754.0 L 588.0 769.0 L 602.0 769.0 L 608.0 771.0 L 608.0 782.0 L 606.0 784.0 L 607.0 795.0 L 604.0 801.0 L 603.0 818.0 L 539.0 850.0 L 535.0 847.0 L 535.0 839.0 L 530.0 829.0 L 531.0 827.0 L 452.0 737.0 L 452.0 733.0 L 479.0 689.0 L 501.0 649.0 Z",
      "position": {
        "x": 528,
        "y": 756
      },
      "badgeAnchor": {
        "x": 526.2,
        "y": 755.3
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t60",
      "name": "Stone Court",
      "adjacencies": [
        "t7",
        "t58",
        "t64",
        "t73"
      ],
      "shape": "M 155.0 665.0 L 234.0 755.0 L 236.0 758.0 L 236.0 764.0 L 141.0 845.0 L 104.0 844.0 L 100.0 841.0 L 100.0 832.0 L 98.0 823.0 L 96.0 821.0 L 97.0 819.0 L 48.0 759.0 L 154.0 666.0 Z M 137.0 699.0 L 139.0 701.0 L 152.0 705.0 L 144.0 715.0 L 153.0 725.0 L 151.0 737.0 L 158.0 748.0 L 158.0 753.0 L 161.0 756.0 L 163.0 754.0 L 163.0 746.0 L 160.0 744.0 L 158.0 738.0 L 171.0 747.0 L 180.0 757.0 L 180.0 768.0 L 178.0 770.0 L 179.0 784.0 L 147.0 814.0 L 147.0 804.0 L 149.0 802.0 L 147.0 800.0 L 120.0 800.0 L 118.0 802.0 L 121.0 806.0 L 143.0 805.0 L 143.0 816.0 L 132.0 816.0 L 124.0 815.0 L 123.0 810.0 L 121.0 808.0 L 119.0 812.0 L 116.0 809.0 L 114.0 810.0 L 100.0 794.0 L 100.0 790.0 L 90.0 779.0 L 90.0 762.0 L 92.0 752.0 L 97.0 748.0 L 97.0 746.0 L 103.0 742.0 L 111.0 742.0 L 113.0 740.0 L 115.0 742.0 L 117.0 740.0 L 118.0 724.0 L 135.0 709.0 L 136.0 700.0 Z",
      "position": {
        "x": 146,
        "y": 757
      },
      "badgeAnchor": {
        "x": 182.62,
        "y": 728.65
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t61",
      "name": "Pike",
      "adjacencies": [
        "t50",
        "t56",
        "t59",
        "t70",
        "t6",
        "t67"
      ],
      "shape": "M 693.0 689.0 L 699.0 692.0 L 760.0 703.0 L 785.0 767.0 L 785.0 770.0 L 706.0 837.0 L 685.0 853.0 L 682.0 859.0 L 607.0 820.0 L 605.0 818.0 L 608.0 783.0 L 607.0 771.0 L 624.0 771.0 L 625.0 755.0 L 612.0 753.0 L 607.0 754.0 L 606.0 752.0 L 627.0 751.0 L 628.0 769.0 L 691.0 716.0 L 692.0 701.0 L 688.0 700.0 L 692.0 695.0 L 692.0 690.0 Z",
      "position": {
        "x": 695,
        "y": 774
      },
      "badgeAnchor": {
        "x": 692.19,
        "y": 781.97
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t62",
      "name": "Mire Sally",
      "adjacencies": [
        "t8",
        "t9",
        "t52"
      ],
      "oneWayBorders": [
        "t57"
      ],
      "borderDice": {
        "t52": {
          "defend": 8
        },
        "t57": {
          "attack": 7
        }
      },
      "shape": "M 1076.0 729.0 L 1080.0 732.0 L 1091.0 751.0 L 1047.0 792.0 L 1040.0 786.0 L 1039.0 762.0 L 1075.0 730.0 Z",
      "position": {
        "x": 1062,
        "y": 759
      },
      "badgeAnchor": {
        "x": 1065.33,
        "y": 759.08
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t63",
      "name": "Dusk Flag",
      "regionId": "flag-t63",
      "adjacencies": [
        "t59",
        "t55",
        "t70"
      ],
      "borderDice": {
        "t6": {
          "defend": 5
        },
        "t55": {
          "defend": 5
        },
        "t59": {
          "defend": 5
        },
        "t70": {
          "defend": 5
        }
      },
      "shape": "M 365.0 734.0 L 372.0 736.0 L 382.0 736.0 L 448.0 744.0 L 453.0 749.0 L 452.0 751.0 L 450.0 749.0 L 449.0 750.0 L 450.0 756.0 L 448.0 759.0 L 489.0 807.0 L 519.0 841.0 L 524.0 841.0 L 522.0 832.0 L 525.0 832.0 L 528.0 842.0 L 524.0 872.0 L 525.0 877.0 L 523.0 879.0 L 517.0 932.0 L 516.0 933.0 L 513.0 930.0 L 514.0 928.0 L 511.0 924.0 L 458.0 860.0 L 450.0 854.0 L 450.0 850.0 L 441.0 843.0 L 438.0 839.0 L 439.0 837.0 L 437.0 834.0 L 428.0 827.0 L 429.0 824.0 L 379.0 761.0 L 371.0 755.0 L 369.0 752.0 L 371.0 747.0 L 367.0 742.0 L 367.0 738.0 L 364.0 735.0 Z",
      "position": {
        "x": 461,
        "y": 822
      },
      "badgeAnchor": {
        "x": 474.55,
        "y": 839.58
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t64",
      "name": "Stone Quarry",
      "adjacencies": [
        "t60",
        "t68",
        "t73",
        "t75"
      ],
      "shape": "M 234.0 767.0 L 236.0 767.0 L 244.0 775.0 L 276.0 813.0 L 235.0 886.0 L 233.0 888.0 L 174.0 888.0 L 143.0 847.0 L 164.0 827.0 L 233.0 768.0 Z",
      "position": {
        "x": 213,
        "y": 835
      },
      "badgeAnchor": {
        "x": 215.26,
        "y": 838.91
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t65",
      "name": "Reach",
      "adjacencies": [
        "t49",
        "t69"
      ],
      "shape": "M 364.0 775.0 L 368.0 778.0 L 390.0 805.0 L 391.0 804.0 L 396.0 810.0 L 398.0 807.0 L 399.0 808.0 L 399.0 813.0 L 403.0 819.0 L 402.0 820.0 L 399.0 817.0 L 349.0 866.0 L 345.0 864.0 L 317.0 831.0 L 311.0 827.0 L 363.0 776.0 Z",
      "position": {
        "x": 355,
        "y": 820
      },
      "badgeAnchor": {
        "x": 359.51,
        "y": 819.46
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t66",
      "name": "Rill",
      "adjacencies": [
        "t52",
        "t72"
      ],
      "shape": "M 906.0 780.0 L 908.0 781.0 L 901.0 789.0 L 941.0 844.0 L 945.0 846.0 L 906.0 884.0 L 873.0 839.0 L 868.0 835.0 L 879.0 825.0 L 879.0 817.0 L 876.0 815.0 L 882.0 808.0 L 884.0 786.0 L 887.0 786.0 L 887.0 795.0 L 889.0 796.0 L 896.0 789.0 L 895.0 788.0 L 897.0 785.0 L 899.0 787.0 L 905.0 781.0 Z",
      "position": {
        "x": 904,
        "y": 835
      },
      "badgeAnchor": {
        "x": 907.7,
        "y": 843.38
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t67",
      "name": "Ember Flag",
      "regionId": "flag-t67",
      "adjacencies": [
        "t61",
        "t56",
        "t70"
      ],
      "borderDice": {
        "t6": {
          "defend": 5
        },
        "t56": {
          "defend": 5
        },
        "t61": {
          "defend": 5
        },
        "t70": {
          "defend": 5
        }
      },
      "shape": "M 790.0 777.0 L 876.0 785.0 L 877.0 791.0 L 875.0 806.0 L 873.0 808.0 L 872.0 807.0 L 720.0 947.0 L 690.0 973.0 L 690.0 976.0 L 687.0 979.0 L 684.0 977.0 L 682.0 979.0 L 680.0 977.0 L 680.0 974.0 L 692.0 858.0 L 695.0 858.0 L 696.0 866.0 L 702.0 861.0 L 705.0 862.0 L 721.0 849.0 L 764.0 813.0 L 773.0 804.0 L 772.0 803.0 L 788.0 789.0 L 787.0 782.0 L 778.0 790.0 L 776.0 789.0 L 789.0 778.0 Z",
      "position": {
        "x": 763,
        "y": 863
      },
      "badgeAnchor": {
        "x": 797.81,
        "y": 837.46
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t68",
      "name": "Stone Granite",
      "adjacencies": [
        "t64",
        "t75",
        "t76",
        "t79"
      ],
      "shape": "M 277.0 815.0 L 332.0 878.0 L 319.0 891.0 L 320.0 893.0 L 318.0 895.0 L 317.0 900.0 L 317.0 912.0 L 319.0 922.0 L 318.0 923.0 L 315.0 920.0 L 313.0 920.0 L 268.0 938.0 L 236.0 890.0 L 238.0 883.0 L 276.0 816.0 Z",
      "position": {
        "x": 282,
        "y": 881
      },
      "badgeAnchor": {
        "x": 279.5,
        "y": 886.11
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t69",
      "name": "Spur",
      "adjacencies": [
        "t65",
        "t76",
        "t80"
      ],
      "shape": "M 400.0 818.0 L 427.0 852.0 L 433.0 858.0 L 434.0 857.0 L 436.0 859.0 L 435.0 861.0 L 439.0 867.0 L 483.0 921.0 L 432.0 971.0 L 429.0 969.0 L 430.0 959.0 L 386.0 911.0 L 383.0 906.0 L 377.0 901.0 L 349.0 868.0 L 399.0 819.0 Z",
      "position": {
        "x": 416,
        "y": 893
      },
      "badgeAnchor": {
        "x": 417.13,
        "y": 895.97
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t70",
      "name": "Shale",
      "adjacencies": [
        "t59",
        "t61",
        "t82",
        "t63",
        "t67"
      ],
      "shape": "M 603.0 820.0 L 679.0 860.0 L 683.0 858.0 L 683.0 855.0 L 685.0 853.0 L 687.0 854.0 L 685.0 856.0 L 684.0 861.0 L 683.0 882.0 L 681.0 890.0 L 676.0 940.0 L 677.0 941.0 L 663.0 941.0 L 661.0 943.0 L 656.0 943.0 L 652.0 940.0 L 628.0 938.0 L 612.0 940.0 L 608.0 937.0 L 593.0 938.0 L 591.0 936.0 L 586.0 935.0 L 575.0 937.0 L 572.0 935.0 L 565.0 936.0 L 563.0 933.0 L 553.0 933.0 L 544.0 931.0 L 534.0 931.0 L 532.0 933.0 L 528.0 933.0 L 525.0 931.0 L 535.0 848.0 L 537.0 847.0 L 540.0 851.0 L 542.0 851.0 L 602.0 821.0 Z",
      "position": {
        "x": 605,
        "y": 887
      },
      "badgeAnchor": {
        "x": 603.47,
        "y": 883.42
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t71",
      "name": "Mire Bog",
      "adjacencies": [
        "t9",
        "t74",
        "t78"
      ],
      "shape": "M 998.0 823.0 L 1000.0 823.0 L 1019.0 842.0 L 1006.0 909.0 L 1004.0 910.0 L 1002.0 908.0 L 980.0 913.0 L 943.0 875.0 L 997.0 824.0 Z",
      "position": {
        "x": 986,
        "y": 870
      },
      "badgeAnchor": {
        "x": 984.56,
        "y": 875.03
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t72",
      "name": "Vale",
      "adjacencies": [
        "t66",
        "t77",
        "t81"
      ],
      "shape": "M 869.0 837.0 L 905.0 885.0 L 822.0 963.0 L 810.0 975.0 L 807.0 981.0 L 766.0 931.0 L 758.0 938.0 L 756.0 937.0 L 764.0 928.0 L 766.0 928.0 L 771.0 923.0 L 771.0 919.0 L 773.0 921.0 L 787.0 908.0 L 789.0 898.0 L 790.0 906.0 L 792.0 907.0 L 823.0 879.0 L 823.0 868.0 L 822.0 867.0 L 817.0 872.0 L 815.0 871.0 L 823.0 863.0 L 825.0 864.0 L 826.0 873.0 L 831.0 868.0 L 834.0 869.0 L 868.0 838.0 Z",
      "position": {
        "x": 834,
        "y": 908
      },
      "badgeAnchor": {
        "x": 837.48,
        "y": 906.75
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t73",
      "name": "Stone Scree",
      "adjacencies": [
        "t60",
        "t64",
        "t75",
        "t84"
      ],
      "shape": "M 101.0 841.0 L 107.0 846.0 L 141.0 846.0 L 172.0 888.0 L 170.0 897.0 L 170.0 911.0 L 167.0 937.0 L 168.0 949.0 L 124.0 951.0 L 67.0 886.0 L 72.0 881.0 L 71.0 879.0 L 80.0 870.0 L 80.0 866.0 L 84.0 866.0 L 99.0 852.0 L 98.0 848.0 L 100.0 846.0 L 100.0 842.0 Z",
      "position": {
        "x": 126,
        "y": 896
      },
      "badgeAnchor": {
        "x": 124.42,
        "y": 890.84
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t74",
      "name": "Mire Silt",
      "adjacencies": [
        "t71",
        "t77",
        "t78",
        "t85",
        "t88",
        "t90",
        "t87"
      ],
      "shape": "M 941.0 877.0 L 978.0 914.0 L 978.0 922.0 L 975.0 931.0 L 974.0 943.0 L 972.0 946.0 L 972.0 952.0 L 969.0 961.0 L 966.0 981.0 L 941.0 1012.0 L 934.0 1019.0 L 929.0 1020.0 L 912.0 1037.0 L 913.0 1039.0 L 897.0 1055.0 L 895.0 1054.0 L 857.0 1090.0 L 853.0 1097.0 L 837.0 1082.0 L 791.0 1087.0 L 763.0 1050.0 L 809.0 1007.0 L 811.0 1007.0 L 837.0 1034.0 L 847.0 1034.0 L 849.0 1032.0 L 848.0 1030.0 L 863.0 1015.0 L 863.0 1009.0 L 864.0 1008.0 L 867.0 1012.0 L 883.0 997.0 L 883.0 989.0 L 878.0 989.0 L 892.0 975.0 L 894.0 976.0 L 885.0 985.0 L 886.0 994.0 L 894.0 986.0 L 897.0 987.0 L 910.0 975.0 L 917.0 968.0 L 916.0 966.0 L 924.0 958.0 L 925.0 948.0 L 923.0 946.0 L 937.0 932.0 L 939.0 933.0 L 927.0 945.0 L 928.0 954.0 L 948.0 935.0 L 946.0 923.0 L 949.0 919.0 L 945.0 914.0 L 946.0 911.0 L 935.0 899.0 L 933.0 900.0 L 931.0 898.0 L 927.0 890.0 L 940.0 878.0 Z",
      "position": {
        "x": 880,
        "y": 1012
      },
      "badgeAnchor": {
        "x": 884.93,
        "y": 1028.8
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t75",
      "name": "Stone Basalt",
      "adjacencies": [
        "t64",
        "t68",
        "t73",
        "t79",
        "t84"
      ],
      "shape": "M 226.0 889.0 L 233.0 889.0 L 236.0 892.0 L 266.0 938.0 L 260.0 952.0 L 258.0 953.0 L 253.0 948.0 L 168.0 950.0 L 167.0 949.0 L 169.0 944.0 L 173.0 893.0 L 172.0 891.0 L 225.0 890.0 Z",
      "position": {
        "x": 212,
        "y": 921
      },
      "badgeAnchor": {
        "x": 209.44,
        "y": 924.38
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t76",
      "name": "Stone Barbican",
      "adjacencies": [
        "t68",
        "t69",
        "t79"
      ],
      "borderDice": {
        "t69": {
          "defend": 7
        }
      },
      "shape": "M 345.0 895.0 L 347.0 895.0 L 359.0 907.0 L 416.0 972.0 L 400.0 986.0 L 396.0 984.0 L 332.0 911.0 L 331.0 908.0 L 344.0 896.0 Z",
      "position": {
        "x": 373,
        "y": 940
      },
      "badgeAnchor": {
        "x": 372.54,
        "y": 940.24
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t77",
      "name": "Mire Barbican",
      "adjacencies": [
        "t72",
        "t74"
      ],
      "borderDice": {
        "t72": {
          "defend": 7
        }
      },
      "shape": "M 909.0 907.0 L 915.0 907.0 L 932.0 925.0 L 843.0 1010.0 L 823.0 988.0 L 908.0 908.0 Z",
      "position": {
        "x": 877,
        "y": 957
      },
      "badgeAnchor": {
        "x": 879.5,
        "y": 952.72
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t78",
      "name": "Mire Reed",
      "adjacencies": [
        "t9",
        "t71",
        "t74",
        "t85"
      ],
      "shape": "M 1003.0 910.0 L 1007.0 911.0 L 1006.0 912.0 L 1016.0 933.0 L 1024.0 956.0 L 1039.0 989.0 L 1037.0 991.0 L 1034.0 989.0 L 1028.0 989.0 L 1018.0 986.0 L 977.0 981.0 L 969.0 978.0 L 969.0 971.0 L 971.0 967.0 L 972.0 956.0 L 974.0 952.0 L 980.0 918.0 L 983.0 914.0 L 1002.0 911.0 Z",
      "position": {
        "x": 999,
        "y": 954
      },
      "badgeAnchor": {
        "x": 997.78,
        "y": 957.74
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t79",
      "name": "Stone Slate",
      "adjacencies": [
        "t68",
        "t75",
        "t76",
        "t84",
        "t86",
        "t89"
      ],
      "shape": "M 315.0 921.0 L 353.0 962.0 L 355.0 960.0 L 356.0 961.0 L 356.0 963.0 L 359.0 966.0 L 359.0 970.0 L 390.0 1004.0 L 393.0 1003.0 L 394.0 994.0 L 400.0 996.0 L 424.0 976.0 L 426.0 977.0 L 426.0 992.0 L 431.0 997.0 L 430.0 999.0 L 435.0 1006.0 L 395.0 1057.0 L 382.0 1058.0 L 326.0 1054.0 L 324.0 1052.0 L 324.0 1035.0 L 320.0 1026.0 L 307.0 1012.0 L 306.0 1013.0 L 301.0 1008.0 L 302.0 1005.0 L 292.0 994.0 L 291.0 995.0 L 288.0 992.0 L 289.0 990.0 L 287.0 987.0 L 260.0 956.0 L 268.0 939.0 L 314.0 922.0 Z",
      "position": {
        "x": 342,
        "y": 995
      },
      "badgeAnchor": {
        "x": 333.16,
        "y": 988.74
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t80",
      "name": "Wold",
      "adjacencies": [
        "t69",
        "t83"
      ],
      "shape": "M 484.0 922.0 L 513.0 958.0 L 508.0 961.0 L 461.0 1007.0 L 450.0 994.0 L 440.0 986.0 L 440.0 982.0 L 432.0 973.0 L 451.0 956.0 L 483.0 923.0 Z",
      "position": {
        "x": 472,
        "y": 965
      },
      "badgeAnchor": {
        "x": 472.29,
        "y": 963.6
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t81",
      "name": "Mound",
      "adjacencies": [
        "t72",
        "t83"
      ],
      "shape": "M 764.0 932.0 L 770.0 937.0 L 771.0 940.0 L 805.0 982.0 L 777.0 1009.0 L 778.0 1011.0 L 768.0 1020.0 L 728.0 966.0 L 763.0 933.0 Z",
      "position": {
        "x": 766,
        "y": 974
      },
      "badgeAnchor": {
        "x": 770.11,
        "y": 980.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t82",
      "name": "South Keep",
      "adjacencies": [
        "t70",
        "t83"
      ],
      "borderDice": {
        "t6": {
          "defend": 7
        },
        "t70": {
          "defend": 7
        },
        "t83": {
          "defend": 7
        },
        "t91": {
          "defend": 7
        },
        "t92": {
          "defend": 7
        }
      },
      "shape": "M 524.0 938.0 L 534.0 941.0 L 541.0 940.0 L 547.0 942.0 L 568.0 943.0 L 568.0 945.0 L 552.0 945.0 L 553.0 952.0 L 563.0 954.0 L 572.0 954.0 L 574.0 952.0 L 575.0 943.0 L 619.0 947.0 L 619.0 949.0 L 603.0 949.0 L 604.0 956.0 L 619.0 958.0 L 622.0 958.0 L 624.0 956.0 L 625.0 947.0 L 642.0 948.0 L 649.0 950.0 L 667.0 950.0 L 670.0 952.0 L 669.0 953.0 L 654.0 952.0 L 653.0 959.0 L 657.0 961.0 L 668.0 961.0 L 671.0 963.0 L 673.0 959.0 L 673.0 977.0 L 671.0 979.0 L 636.0 979.0 L 614.0 1001.0 L 571.0 999.0 L 551.0 974.0 L 545.0 974.0 L 541.0 972.0 L 540.0 969.0 L 530.0 964.0 L 526.0 965.0 L 522.0 962.0 L 524.0 942.0 L 523.0 939.0 Z",
      "position": {
        "x": 595,
        "y": 971
      },
      "badgeAnchor": {
        "x": 594.46,
        "y": 978.44
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t83",
      "name": "Trace",
      "adjacencies": [
        "t80",
        "t81",
        "t91",
        "t92",
        "t82"
      ],
      "shape": "M 512.0 961.0 L 512.0 975.0 L 516.0 980.0 L 545.0 994.0 L 564.0 1017.0 L 566.0 1006.0 L 570.0 1008.0 L 617.0 1010.0 L 642.0 985.0 L 670.0 986.0 L 675.0 984.0 L 691.0 984.0 L 694.0 993.0 L 703.0 985.0 L 705.0 986.0 L 708.0 983.0 L 707.0 982.0 L 713.0 976.0 L 715.0 970.0 L 717.0 972.0 L 721.0 972.0 L 727.0 967.0 L 766.0 1020.0 L 687.0 1095.0 L 685.0 1098.0 L 685.0 1106.0 L 607.0 1179.0 L 600.0 1185.0 L 596.0 1186.0 L 595.0 1184.0 L 598.0 1168.0 L 598.0 1161.0 L 596.0 1159.0 L 597.0 1157.0 L 588.0 1147.0 L 587.0 1148.0 L 580.0 1141.0 L 581.0 1138.0 L 562.0 1116.0 L 550.0 1106.0 L 550.0 1102.0 L 544.0 1096.0 L 537.0 1097.0 L 522.0 1080.0 L 520.0 1082.0 L 519.0 1089.0 L 520.0 1096.0 L 524.0 1100.0 L 527.0 1097.0 L 528.0 1098.0 L 528.0 1106.0 L 519.0 1115.0 L 516.0 1115.0 L 524.0 1106.0 L 523.0 1103.0 L 517.0 1097.0 L 517.0 1090.0 L 515.0 1088.0 L 516.0 1084.0 L 513.0 1081.0 L 516.0 1077.0 L 512.0 1073.0 L 509.0 1066.0 L 507.0 1068.0 L 502.0 1067.0 L 500.0 1065.0 L 497.0 1067.0 L 494.0 1064.0 L 495.0 1061.0 L 497.0 1063.0 L 504.0 1062.0 L 501.0 1059.0 L 501.0 1055.0 L 462.0 1009.0 L 511.0 962.0 Z",
      "position": {
        "x": 614,
        "y": 1055
      },
      "badgeAnchor": {
        "x": 614.04,
        "y": 1079.52
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t84",
      "name": "Stone Flag",
      "regionId": "flag-t84",
      "adjacencies": [
        "t79",
        "t89",
        "t75",
        "t73"
      ],
      "borderDice": {
        "t11": {
          "defend": 5
        },
        "t73": {
          "defend": 5
        },
        "t75": {
          "defend": 5
        },
        "t79": {
          "defend": 5
        },
        "t89": {
          "defend": 5
        }
      },
      "shape": "M 224.0 954.0 L 243.0 955.0 L 240.0 957.0 L 227.0 957.0 L 227.0 965.0 L 245.0 965.0 L 246.0 956.0 L 248.0 954.0 L 255.0 962.0 L 254.0 964.0 L 250.0 960.0 L 249.0 961.0 L 250.0 965.0 L 248.0 969.0 L 251.0 973.0 L 309.0 1041.0 L 311.0 1039.0 L 311.0 1032.0 L 313.0 1032.0 L 315.0 1038.0 L 311.0 1083.0 L 312.0 1092.0 L 310.0 1098.0 L 310.0 1117.0 L 306.0 1155.0 L 308.0 1159.0 L 306.0 1160.0 L 303.0 1158.0 L 301.0 1160.0 L 296.0 1155.0 L 146.0 978.0 L 141.0 973.0 L 140.0 974.0 L 137.0 972.0 L 138.0 969.0 L 131.0 961.0 L 137.0 956.0 L 223.0 955.0 Z",
      "position": {
        "x": 245,
        "y": 1039
      },
      "badgeAnchor": {
        "x": 275.61,
        "y": 1087.58
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t85",
      "name": "Mire Fen",
      "adjacencies": [
        "t9",
        "t74",
        "t78",
        "t87"
      ],
      "shape": "M 967.0 982.0 L 975.0 982.0 L 985.0 985.0 L 994.0 985.0 L 1011.0 989.0 L 1019.0 989.0 L 1029.0 992.0 L 1039.0 992.0 L 1075.0 1022.0 L 1081.0 1029.0 L 1055.0 1055.0 L 1048.0 1056.0 L 1045.0 1054.0 L 1040.0 1055.0 L 1039.0 1052.0 L 961.0 1027.0 L 955.0 1028.0 L 939.0 1022.0 L 930.0 1022.0 L 927.0 1025.0 L 926.0 1023.0 L 929.0 1020.0 L 935.0 1020.0 L 939.0 1016.0 L 966.0 983.0 Z",
      "position": {
        "x": 1010,
        "y": 1017
      },
      "badgeAnchor": {
        "x": 1006.71,
        "y": 1016.57
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t86",
      "name": "Stone Flint",
      "adjacencies": [
        "t11",
        "t79",
        "t89"
      ],
      "shape": "M 436.0 1008.0 L 443.0 1014.0 L 487.0 1067.0 L 490.0 1067.0 L 493.0 1063.0 L 491.0 1060.0 L 492.0 1058.0 L 495.0 1061.0 L 496.0 1068.0 L 489.0 1076.0 L 491.0 1078.0 L 491.0 1082.0 L 488.0 1086.0 L 486.0 1088.0 L 485.0 1087.0 L 485.0 1081.0 L 483.0 1079.0 L 474.0 1085.0 L 471.0 1088.0 L 469.0 1104.0 L 467.0 1107.0 L 465.0 1107.0 L 404.0 1084.0 L 395.0 1059.0 L 435.0 1009.0 Z",
      "position": {
        "x": 441,
        "y": 1061
      },
      "badgeAnchor": {
        "x": 437.61,
        "y": 1059.05
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t87",
      "name": "Mire Flag",
      "regionId": "flag-t87",
      "adjacencies": [
        "t90",
        "t93",
        "t74",
        "t85"
      ],
      "borderDice": {
        "t9": {
          "defend": 5
        },
        "t74": {
          "defend": 5
        },
        "t85": {
          "defend": 5
        },
        "t90": {
          "defend": 5
        },
        "t93": {
          "defend": 5
        }
      },
      "shape": "M 934.0 1028.0 L 947.0 1031.0 L 1042.0 1063.0 L 1043.0 1064.0 L 1035.0 1072.0 L 1036.0 1076.0 L 1034.0 1079.0 L 1031.0 1079.0 L 865.0 1237.0 L 863.0 1240.0 L 863.0 1244.0 L 858.0 1241.0 L 860.0 1226.0 L 859.0 1218.0 L 862.0 1147.0 L 862.0 1097.0 L 869.0 1090.0 L 871.0 1091.0 L 865.0 1097.0 L 866.0 1104.0 L 880.0 1090.0 L 882.0 1084.0 L 884.0 1087.0 L 895.0 1076.0 L 898.0 1077.0 L 929.0 1047.0 L 928.0 1045.0 L 932.0 1040.0 L 932.0 1032.0 L 909.0 1055.0 L 907.0 1054.0 L 933.0 1029.0 Z",
      "position": {
        "x": 928,
        "y": 1120
      },
      "badgeAnchor": {
        "x": 897.22,
        "y": 1164.16
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t88",
      "name": "Mire Peat",
      "adjacencies": [
        "t14",
        "t74",
        "t90"
      ],
      "shape": "M 761.0 1052.0 L 764.0 1054.0 L 790.0 1088.0 L 765.0 1143.0 L 756.0 1145.0 L 726.0 1146.0 L 725.0 1138.0 L 710.0 1119.0 L 702.0 1113.0 L 692.0 1099.0 L 693.0 1097.0 L 695.0 1098.0 L 700.0 1094.0 L 701.0 1095.0 L 696.0 1100.0 L 697.0 1102.0 L 700.0 1105.0 L 704.0 1101.0 L 707.0 1102.0 L 760.0 1053.0 Z",
      "position": {
        "x": 747,
        "y": 1103
      },
      "badgeAnchor": {
        "x": 745.59,
        "y": 1109.28
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t89",
      "name": "Stone Shard",
      "adjacencies": [
        "t11",
        "t79",
        "t86",
        "t84"
      ],
      "shape": "M 321.0 1030.0 L 324.0 1035.0 L 325.0 1054.0 L 333.0 1054.0 L 335.0 1056.0 L 341.0 1057.0 L 393.0 1060.0 L 395.0 1062.0 L 402.0 1085.0 L 323.0 1166.0 L 317.0 1174.0 L 314.0 1177.0 L 311.0 1175.0 L 314.0 1168.0 L 310.0 1162.0 L 314.0 1161.0 L 315.0 1149.0 L 314.0 1146.0 L 316.0 1134.0 L 316.0 1118.0 L 322.0 1045.0 L 322.0 1036.0 L 320.0 1031.0 Z",
      "position": {
        "x": 349,
        "y": 1099
      },
      "badgeAnchor": {
        "x": 351.69,
        "y": 1092.02
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t90",
      "name": "Mire Rush",
      "adjacencies": [
        "t14",
        "t74",
        "t87",
        "t88",
        "t93"
      ],
      "shape": "M 831.0 1084.0 L 837.0 1084.0 L 851.0 1098.0 L 856.0 1093.0 L 857.0 1094.0 L 855.0 1098.0 L 853.0 1176.0 L 854.0 1184.0 L 852.0 1220.0 L 852.0 1245.0 L 854.0 1247.0 L 850.0 1250.0 L 849.0 1249.0 L 851.0 1188.0 L 842.0 1187.0 L 840.0 1185.0 L 801.0 1187.0 L 766.0 1145.0 L 790.0 1091.0 L 793.0 1088.0 L 830.0 1085.0 Z",
      "position": {
        "x": 816,
        "y": 1137
      },
      "badgeAnchor": {
        "x": 812.92,
        "y": 1138.47
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t91",
      "name": "Stone Sally",
      "adjacencies": [
        "t10",
        "t83",
        "t11"
      ],
      "oneWayBorders": [
        "t82"
      ],
      "borderDice": {
        "t82": {
          "attack": 7
        },
        "t83": {
          "defend": 8
        }
      },
      "shape": "M 538.0 1121.0 L 570.0 1157.0 L 578.0 1168.0 L 558.0 1186.0 L 555.0 1187.0 L 527.0 1154.0 L 516.0 1145.0 L 516.0 1141.0 L 537.0 1122.0 Z",
      "position": {
        "x": 546,
        "y": 1154
      },
      "badgeAnchor": {
        "x": 546.03,
        "y": 1152.97
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t92",
      "name": "Mire Postern",
      "adjacencies": [
        "t83",
        "t14"
      ],
      "oneWayBorders": [
        "t82",
        "t88"
      ],
      "borderDice": {
        "t82": {
          "attack": 7
        },
        "t83": {
          "defend": 8
        }
      },
      "shape": "M 687.0 1096.0 L 687.0 1105.0 L 693.0 1113.0 L 692.0 1125.0 L 697.0 1132.0 L 697.0 1136.0 L 706.0 1147.0 L 627.0 1222.0 L 611.0 1204.0 L 611.0 1202.0 L 624.0 1189.0 L 685.0 1131.0 L 684.0 1130.0 L 687.0 1126.0 L 688.0 1119.0 L 687.0 1118.0 L 682.0 1123.0 L 680.0 1122.0 L 689.0 1113.0 L 688.0 1110.0 L 684.0 1107.0 L 686.0 1097.0 Z",
      "position": {
        "x": 659,
        "y": 1172
      },
      "badgeAnchor": {
        "x": 655.91,
        "y": 1175.18
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t93",
      "name": "Mire Loam",
      "adjacencies": [
        "t14",
        "t90",
        "t87"
      ],
      "shape": "M 835.0 1187.0 L 851.0 1188.0 L 850.0 1240.0 L 849.0 1249.0 L 844.0 1254.0 L 844.0 1258.0 L 801.0 1297.0 L 776.0 1274.0 L 801.0 1189.0 L 834.0 1188.0 Z",
      "position": {
        "x": 815,
        "y": 1237
      },
      "badgeAnchor": {
        "x": 819.39,
        "y": 1235.54
      },
      "ownerId": "",
      "armies": 0
    }
  ],
  "ruleOverlay": {
    "sets": [
      {
        "id": "towers",
        "label": "Tower",
        "glyph": "tower",
        "color": "#f59e0b",
        "territories": {
          "nameSuffix": [
            "Tower"
          ]
        }
      },
      {
        "id": "keeps",
        "label": "Fort · Keep",
        "glyph": "keep",
        "color": "#a78bfa",
        "territories": {
          "nameSuffix": [
            "Fort",
            "Keep"
          ]
        }
      },
      {
        "id": "flags",
        "label": "Flag",
        "glyph": "flag",
        "color": "#fb5a76",
        "territories": {
          "nameSuffix": [
            "Flag"
          ]
        }
      },
      {
        "id": "posterns",
        "label": "Postern · Sally",
        "glyph": "gate",
        "color": "#22d3ee",
        "territories": {
          "nameSuffix": [
            "Postern",
            "Sally"
          ]
        }
      },
      {
        "id": "barbicans",
        "label": "Barbican",
        "glyph": "wall",
        "color": "#a3e635",
        "territories": {
          "nameSuffix": [
            "Barbican"
          ]
        }
      },
      {
        "id": "batteries",
        "label": "Battery",
        "glyph": "cannon",
        "color": "#f472b6",
        "territories": {
          "nameSuffix": [
            "Battery"
          ]
        }
      },
      {
        "id": "forts",
        "label": "fort",
        "glyph": "keep",
        "color": "#a78bfa",
        "territories": {
          "nameSuffix": [
            "Fort"
          ]
        }
      },
      {
        "id": "centre",
        "label": "centre",
        "glyph": "swatch",
        "color": "#c9c9c6",
        "territories": {
          "notNamePrefix": [
            "Iron ",
            "Spire ",
            "Stone ",
            "Mire "
          ]
        }
      }
    ],
    "rules": [
      {
        "id": "tower",
        "set": "towers",
        "facts": [
          {
            "kind": "attack",
            "die": 9
          },
          {
            "kind": "reach",
            "steps": "area",
            "oneWay": true,
            "example": "t6"
          },
          {
            "kind": "cap",
            "max": 7
          }
        ]
      },
      {
        "id": "keep",
        "set": "keeps",
        "facts": [
          {
            "kind": "defend",
            "die": 7
          },
          {
            "kind": "bonus",
            "value": 4,
            "label": "fort",
            "set": "forts"
          }
        ]
      },
      {
        "id": "flag",
        "set": "flags",
        "facts": [
          {
            "kind": "defend",
            "die": 5
          },
          {
            "kind": "bonus",
            "value": 3,
            "label": "each"
          }
        ]
      },
      {
        "id": "postern",
        "set": "posterns",
        "facts": [
          {
            "kind": "defend",
            "die": 8,
            "vs": "centre"
          },
          {
            "kind": "reach",
            "to": "keeps",
            "steps": 2,
            "oneWay": true,
            "attack": 7,
            "drawAll": true
          }
        ]
      },
      {
        "id": "barbican",
        "set": "barbicans",
        "facts": [
          {
            "kind": "defend",
            "die": 7,
            "vs": "centre"
          }
        ]
      },
      {
        "id": "battery",
        "set": "batteries",
        "facts": [
          {
            "kind": "bonus",
            "value": 2,
            "label": "each"
          }
        ]
      }
    ],
    "chips": [
      {
        "icon": "cards",
        "label": "Card sets escalate"
      }
    ]
  },
  "geometryVersion": "v1-c7e1e9f4-ffd8266e",
  "seaRoutes": [
    {
      "aId": "t2",
      "bId": "t21",
      "from": {
        "x": 709,
        "y": 191
      },
      "to": {
        "x": 701,
        "y": 192
      }
    },
    {
      "aId": "t3",
      "bId": "t27",
      "from": {
        "x": 245,
        "y": 410
      },
      "to": {
        "x": 247,
        "y": 410
      }
    },
    {
      "aId": "t3",
      "bId": "t40",
      "from": {
        "x": 221,
        "y": 498
      },
      "to": {
        "x": 223,
        "y": 498
      }
    },
    {
      "aId": "t3",
      "bId": "t51",
      "from": {
        "x": 176,
        "y": 541
      },
      "to": {
        "x": 180,
        "y": 565
      }
    },
    {
      "aId": "t6",
      "bId": "t59",
      "from": {
        "x": 534,
        "y": 690
      },
      "to": {
        "x": 526,
        "y": 695
      }
    },
    {
      "aId": "t6",
      "bId": "t61",
      "from": {
        "x": 682,
        "y": 693
      },
      "to": {
        "x": 688,
        "y": 700
      }
    },
    {
      "aId": "t7",
      "bId": "t60",
      "from": {
        "x": 135,
        "y": 699
      },
      "to": {
        "x": 136,
        "y": 700
      }
    },
    {
      "aId": "t9",
      "bId": "t62",
      "from": {
        "x": 1051,
        "y": 797
      },
      "to": {
        "x": 1047,
        "y": 792
      }
    },
    {
      "aId": "t9",
      "bId": "t85",
      "from": {
        "x": 1082,
        "y": 1026
      },
      "to": {
        "x": 1081,
        "y": 1029
      }
    },
    {
      "aId": "t10",
      "bId": "t91",
      "from": {
        "x": 502,
        "y": 1128
      },
      "to": {
        "x": 516,
        "y": 1141
      }
    },
    {
      "aId": "t11",
      "bId": "t86",
      "from": {
        "x": 404,
        "y": 1086
      },
      "to": {
        "x": 404,
        "y": 1084
      }
    },
    {
      "aId": "t11",
      "bId": "t89",
      "from": {
        "x": 404,
        "y": 1086
      },
      "to": {
        "x": 402,
        "y": 1085
      }
    },
    {
      "aId": "t11",
      "bId": "t91",
      "from": {
        "x": 501,
        "y": 1155
      },
      "to": {
        "x": 516,
        "y": 1145
      }
    },
    {
      "aId": "t14",
      "bId": "t90",
      "from": {
        "x": 800,
        "y": 1188
      },
      "to": {
        "x": 801,
        "y": 1187
      }
    },
    {
      "aId": "t14",
      "bId": "t93",
      "from": {
        "x": 800,
        "y": 1188
      },
      "to": {
        "x": 801,
        "y": 1189
      }
    },
    {
      "aId": "t14",
      "bId": "t92",
      "from": {
        "x": 626,
        "y": 1234
      },
      "to": {
        "x": 627,
        "y": 1222
      }
    },
    {
      "aId": "t15",
      "bId": "t16",
      "from": {
        "x": 433,
        "y": 115
      },
      "to": {
        "x": 431,
        "y": 116
      }
    },
    {
      "aId": "t15",
      "bId": "t18",
      "from": {
        "x": 528,
        "y": 236
      },
      "to": {
        "x": 540,
        "y": 248
      }
    },
    {
      "aId": "t15",
      "bId": "t24",
      "from": {
        "x": 515,
        "y": 223
      },
      "to": {
        "x": 513,
        "y": 225
      }
    },
    {
      "aId": "t16",
      "bId": "t20",
      "from": {
        "x": 460,
        "y": 223
      },
      "to": {
        "x": 460,
        "y": 224
      }
    },
    {
      "aId": "t16",
      "bId": "t24",
      "from": {
        "x": 460,
        "y": 223
      },
      "to": {
        "x": 462,
        "y": 225
      }
    },
    {
      "aId": "t17",
      "bId": "t27",
      "from": {
        "x": 217,
        "y": 291
      },
      "to": {
        "x": 208,
        "y": 308
      }
    },
    {
      "aId": "t17",
      "bId": "t26",
      "from": {
        "x": 393,
        "y": 274
      },
      "to": {
        "x": 397,
        "y": 274
      }
    },
    {
      "aId": "t17",
      "bId": "t20",
      "from": {
        "x": 399,
        "y": 187
      },
      "to": {
        "x": 399,
        "y": 187
      }
    },
    {
      "aId": "t18",
      "bId": "t22",
      "from": {
        "x": 546,
        "y": 279
      },
      "to": {
        "x": 547,
        "y": 281
      }
    },
    {
      "aId": "t19",
      "bId": "t23",
      "from": {
        "x": 917,
        "y": 325
      },
      "to": {
        "x": 922,
        "y": 318
      }
    },
    {
      "aId": "t19",
      "bId": "t25",
      "from": {
        "x": 805,
        "y": 254
      },
      "to": {
        "x": 802,
        "y": 254
      }
    },
    {
      "aId": "t19",
      "bId": "t28",
      "from": {
        "x": 910,
        "y": 323
      },
      "to": {
        "x": 910,
        "y": 323
      }
    },
    {
      "aId": "t20",
      "bId": "t24",
      "from": {
        "x": 460,
        "y": 224
      },
      "to": {
        "x": 462,
        "y": 225
      }
    },
    {
      "aId": "t21",
      "bId": "t22",
      "from": {
        "x": 673,
        "y": 218
      },
      "to": {
        "x": 663,
        "y": 229
      }
    },
    {
      "aId": "t22",
      "bId": "t30",
      "from": {
        "x": 561,
        "y": 373
      },
      "to": {
        "x": 561,
        "y": 376
      }
    },
    {
      "aId": "t22",
      "bId": "t31",
      "from": {
        "x": 773,
        "y": 349
      },
      "to": {
        "x": 774,
        "y": 350
      }
    },
    {
      "aId": "t22",
      "bId": "t35",
      "from": {
        "x": 715,
        "y": 375
      },
      "to": {
        "x": 712,
        "y": 380
      }
    },
    {
      "aId": "t23",
      "bId": "t37",
      "from": {
        "x": 988,
        "y": 385
      },
      "to": {
        "x": 990,
        "y": 406
      }
    },
    {
      "aId": "t23",
      "bId": "t32",
      "from": {
        "x": 988,
        "y": 385
      },
      "to": {
        "x": 980,
        "y": 406
      }
    },
    {
      "aId": "t24",
      "bId": "t26",
      "from": {
        "x": 452,
        "y": 275
      },
      "to": {
        "x": 451,
        "y": 276
      }
    },
    {
      "aId": "t26",
      "bId": "t29",
      "from": {
        "x": 443,
        "y": 333
      },
      "to": {
        "x": 442,
        "y": 334
      }
    },
    {
      "aId": "t26",
      "bId": "t33",
      "from": {
        "x": 363,
        "y": 376
      },
      "to": {
        "x": 361,
        "y": 378
      }
    },
    {
      "aId": "t27",
      "bId": "t33",
      "from": {
        "x": 269,
        "y": 411
      },
      "to": {
        "x": 269,
        "y": 413
      }
    },
    {
      "aId": "t27",
      "bId": "t40",
      "from": {
        "x": 247,
        "y": 410
      },
      "to": {
        "x": 247,
        "y": 411
      }
    },
    {
      "aId": "t28",
      "bId": "t36",
      "from": {
        "x": 848,
        "y": 364
      },
      "to": {
        "x": 844,
        "y": 369
      }
    },
    {
      "aId": "t29",
      "bId": "t33",
      "from": {
        "x": 344,
        "y": 407
      },
      "to": {
        "x": 337,
        "y": 403
      }
    },
    {
      "aId": "t30",
      "bId": "t34",
      "from": {
        "x": 534,
        "y": 416
      },
      "to": {
        "x": 532,
        "y": 417
      }
    },
    {
      "aId": "t31",
      "bId": "t38",
      "from": {
        "x": 820,
        "y": 400
      },
      "to": {
        "x": 819,
        "y": 400
      }
    },
    {
      "aId": "t32",
      "bId": "t36",
      "from": {
        "x": 927,
        "y": 442
      },
      "to": {
        "x": 907,
        "y": 448
      }
    },
    {
      "aId": "t32",
      "bId": "t39",
      "from": {
        "x": 980,
        "y": 406
      },
      "to": {
        "x": 982,
        "y": 407
      }
    },
    {
      "aId": "t33",
      "bId": "t40",
      "from": {
        "x": 269,
        "y": 413
      },
      "to": {
        "x": 269,
        "y": 415
      }
    },
    {
      "aId": "t34",
      "bId": "t45",
      "from": {
        "x": 433,
        "y": 503
      },
      "to": {
        "x": 432,
        "y": 504
      }
    },
    {
      "aId": "t35",
      "bId": "t44",
      "from": {
        "x": 566,
        "y": 420
      },
      "to": {
        "x": 566,
        "y": 426
      }
    },
    {
      "aId": "t36",
      "bId": "t38",
      "from": {
        "x": 893,
        "y": 461
      },
      "to": {
        "x": 893,
        "y": 461
      }
    },
    {
      "aId": "t36",
      "bId": "t39",
      "from": {
        "x": 907,
        "y": 448
      },
      "to": {
        "x": 927,
        "y": 453
      }
    },
    {
      "aId": "t37",
      "bId": "t39",
      "from": {
        "x": 1025,
        "y": 467
      },
      "to": {
        "x": 1023,
        "y": 467
      }
    },
    {
      "aId": "t37",
      "bId": "t41",
      "from": {
        "x": 1112,
        "y": 411
      },
      "to": {
        "x": 1113,
        "y": 413
      }
    },
    {
      "aId": "t38",
      "bId": "t47",
      "from": {
        "x": 891,
        "y": 482
      },
      "to": {
        "x": 891,
        "y": 484
      }
    },
    {
      "aId": "t39",
      "bId": "t46",
      "from": {
        "x": 1019,
        "y": 470
      },
      "to": {
        "x": 1021,
        "y": 471
      }
    },
    {
      "aId": "t41",
      "bId": "t46",
      "from": {
        "x": 1002,
        "y": 542
      },
      "to": {
        "x": 1001,
        "y": 540
      }
    },
    {
      "aId": "t41",
      "bId": "t54",
      "from": {
        "x": 1085,
        "y": 632
      },
      "to": {
        "x": 1073,
        "y": 645
      }
    },
    {
      "aId": "t42",
      "bId": "t44",
      "from": {
        "x": 709,
        "y": 505
      },
      "to": {
        "x": 702,
        "y": 505
      }
    },
    {
      "aId": "t42",
      "bId": "t56",
      "from": {
        "x": 791,
        "y": 595
      },
      "to": {
        "x": 787,
        "y": 603
      }
    },
    {
      "aId": "t43",
      "bId": "t48",
      "from": {
        "x": 553,
        "y": 495
      },
      "to": {
        "x": 559,
        "y": 498
      }
    },
    {
      "aId": "t43",
      "bId": "t44",
      "from": {
        "x": 559,
        "y": 426
      },
      "to": {
        "x": 565,
        "y": 427
      }
    },
    {
      "aId": "t43",
      "bId": "t55",
      "from": {
        "x": 478,
        "y": 557
      },
      "to": {
        "x": 480,
        "y": 565
      }
    },
    {
      "aId": "t45",
      "bId": "t49",
      "from": {
        "x": 391,
        "y": 540
      },
      "to": {
        "x": 390,
        "y": 542
      }
    },
    {
      "aId": "t47",
      "bId": "t52",
      "from": {
        "x": 945,
        "y": 541
      },
      "to": {
        "x": 946,
        "y": 543
      }
    },
    {
      "aId": "t48",
      "bId": "t59",
      "from": {
        "x": 541,
        "y": 658
      },
      "to": {
        "x": 539,
        "y": 658
      }
    },
    {
      "aId": "t49",
      "bId": "t51",
      "from": {
        "x": 224,
        "y": 595
      },
      "to": {
        "x": 221,
        "y": 590
      }
    },
    {
      "aId": "t49",
      "bId": "t53",
      "from": {
        "x": 349,
        "y": 575
      },
      "to": {
        "x": 354,
        "y": 580
      }
    },
    {
      "aId": "t49",
      "bId": "t58",
      "from": {
        "x": 203,
        "y": 634
      },
      "to": {
        "x": 186,
        "y": 640
      }
    },
    {
      "aId": "t50",
      "bId": "t61",
      "from": {
        "x": 693,
        "y": 690
      },
      "to": {
        "x": 693,
        "y": 689
      }
    },
    {
      "aId": "t52",
      "bId": "t54",
      "from": {
        "x": 974,
        "y": 571
      },
      "to": {
        "x": 982,
        "y": 571
      }
    },
    {
      "aId": "t52",
      "bId": "t57",
      "from": {
        "x": 898,
        "y": 599
      },
      "to": {
        "x": 892,
        "y": 600
      }
    },
    {
      "aId": "t53",
      "bId": "t55",
      "from": {
        "x": 393,
        "y": 724
      },
      "to": {
        "x": 396,
        "y": 724
      }
    },
    {
      "aId": "t55",
      "bId": "t59",
      "from": {
        "x": 453,
        "y": 738
      },
      "to": {
        "x": 452,
        "y": 737
      }
    },
    {
      "aId": "t55",
      "bId": "t63",
      "from": {
        "x": 451,
        "y": 739
      },
      "to": {
        "x": 448,
        "y": 744
      }
    },
    {
      "aId": "t56",
      "bId": "t57",
      "from": {
        "x": 860,
        "y": 777
      },
      "to": {
        "x": 864,
        "y": 777
      }
    },
    {
      "aId": "t56",
      "bId": "t61",
      "from": {
        "x": 784,
        "y": 771
      },
      "to": {
        "x": 785,
        "y": 770
      }
    },
    {
      "aId": "t56",
      "bId": "t67",
      "from": {
        "x": 784,
        "y": 771
      },
      "to": {
        "x": 790,
        "y": 777
      }
    },
    {
      "aId": "t58",
      "bId": "t60",
      "from": {
        "x": 169,
        "y": 653
      },
      "to": {
        "x": 155,
        "y": 665
      }
    },
    {
      "aId": "t59",
      "bId": "t63",
      "from": {
        "x": 530,
        "y": 829
      },
      "to": {
        "x": 525,
        "y": 832
      }
    },
    {
      "aId": "t60",
      "bId": "t64",
      "from": {
        "x": 141,
        "y": 845
      },
      "to": {
        "x": 143,
        "y": 847
      }
    },
    {
      "aId": "t63",
      "bId": "t70",
      "from": {
        "x": 517,
        "y": 932
      },
      "to": {
        "x": 525,
        "y": 931
      }
    },
    {
      "aId": "t64",
      "bId": "t68",
      "from": {
        "x": 276,
        "y": 813
      },
      "to": {
        "x": 277,
        "y": 815
      }
    },
    {
      "aId": "t64",
      "bId": "t73",
      "from": {
        "x": 174,
        "y": 888
      },
      "to": {
        "x": 172,
        "y": 888
      }
    },
    {
      "aId": "t64",
      "bId": "t75",
      "from": {
        "x": 233,
        "y": 888
      },
      "to": {
        "x": 233,
        "y": 889
      }
    },
    {
      "aId": "t65",
      "bId": "t69",
      "from": {
        "x": 399,
        "y": 817
      },
      "to": {
        "x": 400,
        "y": 818
      }
    },
    {
      "aId": "t67",
      "bId": "t70",
      "from": {
        "x": 692,
        "y": 858
      },
      "to": {
        "x": 687,
        "y": 854
      }
    },
    {
      "aId": "t68",
      "bId": "t75",
      "from": {
        "x": 268,
        "y": 938
      },
      "to": {
        "x": 266,
        "y": 938
      }
    },
    {
      "aId": "t68",
      "bId": "t76",
      "from": {
        "x": 317,
        "y": 912
      },
      "to": {
        "x": 331,
        "y": 908
      }
    },
    {
      "aId": "t69",
      "bId": "t76",
      "from": {
        "x": 429,
        "y": 969
      },
      "to": {
        "x": 416,
        "y": 972
      }
    },
    {
      "aId": "t69",
      "bId": "t80",
      "from": {
        "x": 483,
        "y": 921
      },
      "to": {
        "x": 484,
        "y": 922
      }
    },
    {
      "aId": "t70",
      "bId": "t82",
      "from": {
        "x": 575,
        "y": 937
      },
      "to": {
        "x": 575,
        "y": 943
      }
    },
    {
      "aId": "t71",
      "bId": "t74",
      "from": {
        "x": 980,
        "y": 913
      },
      "to": {
        "x": 978,
        "y": 914
      }
    },
    {
      "aId": "t71",
      "bId": "t78",
      "from": {
        "x": 1004,
        "y": 910
      },
      "to": {
        "x": 1003,
        "y": 910
      }
    },
    {
      "aId": "t73",
      "bId": "t75",
      "from": {
        "x": 168,
        "y": 949
      },
      "to": {
        "x": 168,
        "y": 950
      }
    },
    {
      "aId": "t73",
      "bId": "t84",
      "from": {
        "x": 124,
        "y": 951
      },
      "to": {
        "x": 131,
        "y": 961
      }
    },
    {
      "aId": "t74",
      "bId": "t77",
      "from": {
        "x": 937,
        "y": 932
      },
      "to": {
        "x": 932,
        "y": 925
      }
    },
    {
      "aId": "t74",
      "bId": "t78",
      "from": {
        "x": 972,
        "y": 952
      },
      "to": {
        "x": 974,
        "y": 952
      }
    },
    {
      "aId": "t74",
      "bId": "t88",
      "from": {
        "x": 791,
        "y": 1087
      },
      "to": {
        "x": 790,
        "y": 1088
      }
    },
    {
      "aId": "t74",
      "bId": "t90",
      "from": {
        "x": 837,
        "y": 1082
      },
      "to": {
        "x": 837,
        "y": 1084
      }
    },
    {
      "aId": "t74",
      "bId": "t87",
      "from": {
        "x": 857,
        "y": 1090
      },
      "to": {
        "x": 862,
        "y": 1097
      }
    },
    {
      "aId": "t75",
      "bId": "t79",
      "from": {
        "x": 266,
        "y": 938
      },
      "to": {
        "x": 268,
        "y": 939
      }
    },
    {
      "aId": "t75",
      "bId": "t84",
      "from": {
        "x": 253,
        "y": 948
      },
      "to": {
        "x": 248,
        "y": 954
      }
    },
    {
      "aId": "t76",
      "bId": "t79",
      "from": {
        "x": 416,
        "y": 972
      },
      "to": {
        "x": 424,
        "y": 976
      }
    },
    {
      "aId": "t78",
      "bId": "t85",
      "from": {
        "x": 1037,
        "y": 991
      },
      "to": {
        "x": 1039,
        "y": 992
      }
    },
    {
      "aId": "t79",
      "bId": "t84",
      "from": {
        "x": 260,
        "y": 956
      },
      "to": {
        "x": 255,
        "y": 962
      }
    },
    {
      "aId": "t79",
      "bId": "t86",
      "from": {
        "x": 395,
        "y": 1057
      },
      "to": {
        "x": 395,
        "y": 1059
      }
    },
    {
      "aId": "t80",
      "bId": "t83",
      "from": {
        "x": 461,
        "y": 1007
      },
      "to": {
        "x": 462,
        "y": 1009
      }
    },
    {
      "aId": "t81",
      "bId": "t83",
      "from": {
        "x": 728,
        "y": 966
      },
      "to": {
        "x": 727,
        "y": 967
      }
    },
    {
      "aId": "t82",
      "bId": "t83",
      "from": {
        "x": 671,
        "y": 979
      },
      "to": {
        "x": 675,
        "y": 984
      }
    },
    {
      "aId": "t83",
      "bId": "t91",
      "from": {
        "x": 528,
        "y": 1106
      },
      "to": {
        "x": 538,
        "y": 1121
      }
    },
    {
      "aId": "t84",
      "bId": "t89",
      "from": {
        "x": 308,
        "y": 1159
      },
      "to": {
        "x": 310,
        "y": 1162
      }
    },
    {
      "aId": "t85",
      "bId": "t87",
      "from": {
        "x": 930,
        "y": 1022
      },
      "to": {
        "x": 934,
        "y": 1028
      }
    },
    {
      "aId": "t86",
      "bId": "t89",
      "from": {
        "x": 404,
        "y": 1084
      },
      "to": {
        "x": 402,
        "y": 1085
      }
    },
    {
      "aId": "t87",
      "bId": "t90",
      "from": {
        "x": 862,
        "y": 1097
      },
      "to": {
        "x": 857,
        "y": 1094
      }
    },
    {
      "aId": "t88",
      "bId": "t90",
      "from": {
        "x": 765,
        "y": 1143
      },
      "to": {
        "x": 766,
        "y": 1145
      }
    },
    {
      "aId": "t3",
      "bId": "t17",
      "from": {
        "x": 171,
        "y": 337
      },
      "to": {
        "x": 217,
        "y": 291
      },
      "oneWay": true
    },
    {
      "aId": "t3",
      "bId": "t33",
      "from": {
        "x": 245,
        "y": 410
      },
      "to": {
        "x": 269,
        "y": 413
      },
      "oneWay": true
    },
    {
      "aId": "t9",
      "bId": "t92",
      "from": {
        "x": 700,
        "y": 1094
      },
      "to": {
        "x": 687,
        "y": 1096
      },
      "oneWay": true
    },
    {
      "aId": "t9",
      "bId": "t77",
      "from": {
        "x": 846,
        "y": 1019
      },
      "to": {
        "x": 843,
        "y": 1010
      },
      "oneWay": true
    },
    {
      "aId": "t11",
      "bId": "t10",
      "from": {
        "x": 467,
        "y": 1109
      },
      "to": {
        "x": 479,
        "y": 1103
      },
      "oneWay": true
    },
    {
      "aId": "t51",
      "bId": "t40",
      "from": {
        "x": 251,
        "y": 549
      },
      "to": {
        "x": 261,
        "y": 540
      },
      "oneWay": true
    },
    {
      "aId": "t92",
      "bId": "t88",
      "from": {
        "x": 687,
        "y": 1096
      },
      "to": {
        "x": 692,
        "y": 1099
      },
      "oneWay": true
    }
  ]
}
